<template>
  <div class="order">
    <!-- 步骤标题 -->
    <div class="order-step w">
      <div class="order-step-right" v-if="currentNavSubList.length > 0">
        <button
          v-for="(sub, j) in currentNavSubList"
          :key="j"
          :class="['nav-sub-btn', { active: common.navSelect.navSubIndex === j }]"
          @click="onSubNavChange(j)">
          {{ sub.navLabel }}
        </button>
      </div>
    </div>
    <el-card class="order-box w" :body-style="{ padding: 0 }" style="min-height: calc(100vh - 193px);">
      <template slot="header">
        <div class="order-step-left">
          <div class="order-step-wrap" v-for="(item, i) in stepList" :key="i"
               :class="[currentStep === item.step ? 'step-active' : '', currentStep > item.step ? 'step-done' : '']">
            <div class="step-number">{{ i + 1 }}</div>
            <span>{{ item.name }}</span>
            <i v-if="i < stepList.length - 1" class="step-arrow el-icon-arrow-right"
               :class="currentStep > item.step ? 'arrow-done' : ''"></i>
          </div>
        </div>
      </template>
      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
           style="min-height: calc(100vh - 220px);">
        <!-- 选中显示标题 -->
        <div class="order-title">
          {{ form.demName }} {{ catalogTitle }} <span v-if="currentStep != 1 && form.demPatient">【{{
            form.demPatient
          }}】</span>
        </div>

        <!-- 步骤一 -->
        <div class="order-detail-catalog" style="min-height: calc(100vh - 313px);" v-if="currentStep === 1">
          <!-- 主目录 -->
          <section class="order-catalog">
            <ul class="box">
              <li class="content" v-for="(item, i) in catalogList" :key="i" @click="changeMainCatalog(i)"
                  :class="currentCatalog === i ? 'active' : ''">
                <img class="i" :src="item.iconSelect" v-if="currentCatalog === i">
                <img class="i" :src="item.icon" v-else>
                <span>{{ item.name }}</span>
                <a class="cover-link"></a>
              </li>
            </ul>
          </section>
          <!-- 子目录 -->
          <section class="order-sub-catalog">
            <ul class="box">
              <li class="content" v-for="(item, j) in subCatalogList" :key="j" @click="changeSubCatalog(j)"
                  :class="currentSubCatalog === j ? 'active' : ''"
                  :id="currentCatalog == 0 && user.demServType != '00' ? 'clinic' : 'factory'">
                <div class="sub-box">
                  <img class="i" :src="item.icon">
                  <span>{{ item.name }}</span>
                  <a class="cover-link"></a>
                </div>
              </li>
            </ul>
          </section>
        </div>
        <!-- 步骤二 -->
        <div class="order-detail-design" style="min-height: calc(100vh - 313px);"
             v-if="currentStep === 2 && subCatalogId != '3010130'">
          <!-- 1、基本信息 -->
          <div class="order-basic-wrap">
            <base-tag label="基本信息" style="position: relative;"></base-tag>
            <y-tooth @select-tooth="changeOrderCount" :singleDataList="singleDataList" :bridgeDataList="bridgeDataList"
                     @flagChange="judgeJaw" @sendBridge="sendBridge" :subCatalogId="subCatalogId"
                     :servBridge="servBridge"
                     @checkChange="checkChange" :isCreate="isCreate" :options1="options1" :options2="options2"
                     :options3="options3" v-if="common.serv.get(subCatalogId).isTooth == '1'" :flagBridge="flagBridge"/>
            <input-field inputClass="contact" :label="'下单名称'" v-model="form.demContact"
                         :customStyle="{ '--inputColorContact': colorContact }"
                         :readonly="user.demServType == '00' ? true : false"
                         @input="change1" required/>
            <input-field inputClass="phone" label="联系方式" v-model="form.demPhone"
                         :customStyle="{ '--inputColorPhone': colorPhone }" :readonly="false" @input="change2"
                         required/>
            <input-field inputClass="patient" label="患者姓名" v-model="form.demPatient"
                         :customStyle="{ '--inputColorPatient': colorPatient }" :readonly="false" @input="change3"
                         required/>
            <select-field label="患者性别" v-model="form.demSex" :options="demSexMap" placeholder="请选择性别"
                          required/>
          </div>
          <!--2、设计费详情 -->
          <div class="order-input-wrap">
            <base-tag label="设计费详情"></base-tag>
            <input-field :label="subCatalogId == '1010410' ? '桥架数量' : '数量'" v-model="form.orderCount"
                         :readonly="true"
                         :inputClass="rowFactory ? 'factory' : ''" required/>
            <input-field label="单价" v-model="form.orderPrice" :readonly="true"
                         :inputClass="rowFactory ? 'factory' : ''"
                         required/>
            <!-- 适应症主类选择上部种植修复时 -->
            <input-field v-if="fund > 0" label="基台数量" v-model="fund" :readonly="true" required/>
            <input-field v-if="fund > 0" label="基台单价" v-model="basePrice" :readonly="true" required/>
            <!-- 适应症主类选择基台时 -->
            <input-field v-if="showUpperCrownInfo"
                         :label="subCatalogId !== '1010120' ? '上部冠数量' : '基台数量'" v-model="quantity"
                         :readonly="true"
                         :inputClass="fund > 0 && quantity > 0 && user.demServType == '00' ? 'base' : ''" required/>
            <input-field v-if="showUpperCrownInfo"
                         :label="subCatalogId !== '1010120' ? '上部冠单价' : '基台单价'" v-model="extraUnitPrice"
                         :readonly="true"
                         :inputClass="fund > 0 && quantity > 0 && user.demServType == '00' ? 'base' : ''" required/>
            <select-field v-if="showLevel" label="设计师级别" v-model="form.desLevel" :options="desLevelMap"
                          placeholder="请选择设计师级别" @input="calAmount"
                          :inputClass="rowFactory || (fund > 0 && quantity > 0) ? 'factory' : ''"/>
            <input-number-field label="是否加急(元)" v-model="form.orderRushFee" @input="calAmount"
                                :disabled="isEditServOrder == '1'" :isEditServOrder="isEditServOrder"
                                :inputClass="(rowFactory || (fund > 0 && quantity > 0)) && user.demServType == '00' ? 'factory' : ''"
                                required/>
            <input-field label="总价" v-model="form.orderAmount" :readonly="true"
                         :inputClass="(rowFactory || (fund > 0 && quantity > 0)) && user.demServType == '00' ? 'factory' : ''"
                         required/>
            <radio-field v-if="catalogId == '20'" style="width: 30%;margin-left: 0.1%;" @input="calAmount"
                         label="口扫模型编辑" v-model="form.isEditScanModel" oneText="否"
                         :twoText="editScanModelText" required/>
          </div>
          <!-- 3、设计需求 -->
          <div class="order-input-wrap" v-if="showDesignReq">
            <base-tag label="设计需求"></base-tag>
            <div class="input-form-wrap-row el-select-input" v-if="showDesignReq">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>修复体材质</span>
              </div>
              <el-select class="input-form" v-model="form.repairMaterial" placeholder="请选择修复体材质" size="mini">
                <el-option class="option-item" label="氧化锆" value="00"></el-option>
                <el-option class="option-item" label="玻璃陶瓷" value="01"></el-option>
                <el-option class="option-item" label="树脂" value="02"></el-option>
              </el-select>
            </div>
            <!-- 冠部是否开孔-->
            <div class="input-form-wrap" v-if="showHole"
                 style="padding: 10px 0px;width: 280px;margin-left: 15px;" @change="changePosHole">
              <div class="input-label" style="margin-left: -5%;">
                <span style="color:red">*</span>
                <span>冠部是否开孔</span>
              </div>
              <div class="input-radio" style="width: 130px;">
                <div class="input-radio-box">
                  <!-- 添加 aria-label 来描述单选按钮的功能 -->
                  <el-radio v-model="form.posHole" label="0" aria-label="否">否</el-radio>
                  <el-radio v-model="form.posHole" label="1" aria-label="是">是</el-radio>
                </div>
              </div>
            </div>
            <!-- 开孔直径 -- 仅=>种植上部修复冠 -->
            <input-number-field label="开孔直径" v-if="form.posHole == '1'" required v-model="form.holeDiameter"
                                style="line-height: 40px;margin-left: -5px" :step="0.1" :suffixText="'mm'"/>
            <radio-field
              v-if="catalogId == '10' && subCatalogId != '1010698' && subCatalogId != '1010699' && subCatalogId != '1010410' && subCatalogId != '1010700'"
              style="width: 27%;padding: 10px 10px;line-height: 40px;margin-left: -5px;" @input="calAmount"
              label="口扫模型编辑" oneText="否" v-model="form.isEditScanModel"
              :twoText="editScanModelText" required/>
          </div>
          <!--4、复合适应症-->
          <div class="order-input-wrap"
               v-if="['1010120','1010210','1010220','1010410'].includes(subCatalogId)">
            <SelIndication @handleIndication="handleIndication" :subCatalogId="subCatalogId"
                           :currentStep="currentStep"/>
          </div>
          <!-- 4.1、额外适应症需求 -->
          <div class="order-input-wrap"
               v-if="quantity > 0||(subCatalogId=='1010120'&&(options2==true||options3==true))||
           (['1010210','1010220'].includes(subCatalogId)&&options1==true)">
            <base-tag label="种植上部修复冠设计需求"
                      v-if="subCatalogId == '1010210' || subCatalogId == '1010220'"></base-tag>
            <base-tag label="基台设计需求" v-if="subCatalogId == '1010120'"></base-tag>
            <ImpSys @handleImp="handleImp" :subCatalogId="subCatalogId" :catalogId="catalogId"
                    :isEditServOrder="isEditServOrder" :designFlag="true" :orderDetail="form" :transmit="false"/>
          </div>
          <!--5、种植体信息 -->
          <div class="order-input-wrap"
               v-if="common.serv.get(subCatalogId).isImpSystem == '1' && (subCatalogId != '1010120')">
            <base-tag label="种植体信息"></base-tag>
            <ImpSys @handleImp="handleImp" :subCatalogId="subCatalogId" :catalogId="catalogId"
                    :isEditServOrder="isEditServOrder" :transmit="false" :orderDetail="form"/>
          </div>
          <!-- 6、器械规格 -->
          <div class="order-input-wrap" v-if="subCatalogId == '1010698' || subCatalogId == '1010699'">
            <base-tag label="器械规格"></base-tag>
            <div class="input-form-wrap" style="margin-left: -2%;">
              <div class="input-label" style="margin-left: 4.5%;">
                <span style="color:red">*</span>
                <span>手术器械盒供应商</span>
              </div>
              <el-input class="input-form" v-model="form.surgicalBoxSupplier" size="mini"
                        placeholder="请输入手术器械盒供应商"/>
            </div>

            <div class="input-form-wrap" style="margin-left: -1%;">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>导环规格和型号：</span>
              </div>
              <el-input class="input-form" v-model="form.plantModel" size="mini" placeholder="请输入导环规格和型号"/>
            </div>
          </div>
          <!--7、备注信息 -->
          <div class="order-input-wrap">
            <base-tag label="备注信息"></base-tag>
            <div class="input-textarea">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }" placeholder="请输入备注信息"
                        v-model="form.orderRemark"/>
            </div>
          </div>
          <div class="order-input-wrap" v-if="remarkHistory.length != 0">
            <base-tag label="快捷标签"></base-tag>
            <div class="item-history">
              <el-tag v-for="(item, index) in remarkHistory" :key="index" @click="replaceStr(index)"
                      @close="removeItem(index)" closable style="margin: 5px 5px;">{{ item }}
              </el-tag>
            </div>
          </div>
        </div>
        <!-- 步骤三 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="this.currentStep === 3">
          <div class="input-type-wrap"
               v-if="common.serv.get(subCatalogId).isDataType == '1' || common.serv.get(subCatalogId).isSoftType == '1' || (common.serv.get(subCatalogId).isDeviceType == '1' && (user.demServType == '10' || user.demServType == '11') && subCatalogId != '1010698' && subCatalogId != '1010699')">
            <base-tag label="数据信息"></base-tag>
            <div class="input-form-wrap" v-if="common.serv.get(subCatalogId).isDataType == '1'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>数据类型</span>
              </div>
              <el-select class="input-select" v-model="form.dataType" placeholder="请选择数据类型" size="mini">
                <el-option class="option-item" v-for="item in common.dict.get('biz_scan_type')" :key="item.value"
                           :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div v-if="form.dataType == '99'">
                <el-input class="input-form" v-model="form.otherDataType" placeholder="请输入数据类型" size="mini"/>
              </div>
            </div>
            <div class="input-form-wrap" v-if="common.serv.get(subCatalogId).isSoftType == '1'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>扫描仪品牌</span>
              </div>
              <el-select class="input-select" v-model="form.softType" placeholder="请选择软件种类" size="mini">
                <el-option class="option-item" v-for="item in common.dict.get('biz_soft_type')" :key="item.value"
                           :label="item.label" :value="item.value"/>
              </el-select>
              <div v-if="form.softType == '99'">
                <el-input class="input-form" v-model="form.otherSoftType" placeholder="请输入扫描仪品牌" size="mini"/>
              </div>
            </div>
            <div v-if="showDeviceList&&subCatalogId!='1010410'" class="input-form-wrap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>CAM制造设备名称</span>
              </div>
              <el-select class="input-select" v-model="form.deviceType" placeholder="请选择设备型号"
                         @change="changeDeviceType()" size="mini">
                <el-option class="option-item" v-for="item in devicelists" :key="item.value" :label="item.label"
                           :value="item.value"/>
              </el-select>
              <div v-if="form.deviceType == '99'">
                <el-input class="input-form" v-model="form.otherDeviceType" placeholder="请输入设备型号" size="mini"/>
              </div>
            </div>
          </div>
          <!-- 参数信息 -->
          <div class="order-input-wrap"
               v-if="subCatalogId != '1010700' && subCatalogId != '1010410' && subCatalogId != '1010510'"
               :key="renovate">
            <div style="display: flex; align-items: center;">
              <div style="margin-right: 170px;">
                <base-tag class="param-info" label="参数信息"></base-tag>
              </div>
            </div>
            <div style="margin-left: 55px; margin-top: 10px;" v-if="isShowTemplate"
                 :style="subCatalogId == '1010698' || subCatalogId == '1010699' ? 'position: absolute;top: 40px;left:578px;' : ''">
              <span>使用模版</span>
              <el-select v-model="templateItem" size="small" ref="select" @change="changeTemplate()"
                         style="width: 186px;margin-left: 45px; margin-bottom: 13px;" placeholder="使用模版">
                <el-option v-for="(item, index) in templateOptions" :key="index" :label="item.title" :value="item.id"
                           style="width: 300px;">
                  <span class="toLeft">{{ item.title }}&nbsp;</span>
                  <p class="toRight" v-show="item.id != '9999'">
                    <span class="toLeft" @click="updateItem(item.id)">
                      <span class="editText">编辑</span>
                    </span>
                    <span class="toRight" @click="removeTemplateItem(item.id)">
                      <span class="removeText">删除</span>
                    </span>
                  </p>
                </el-option>
                <div style="width: auto;height: 34px;line-height: 34px;">
                  <a style="margin-left: 30px;" @click.prevent="createTempate">生成模版</a>
                </div>
              </el-select>
              <span style="margin-left: 90px;"
                    v-if="['2010120','2010210','2010220','2010320','2010420','1010120'].includes(subCatalogId)&&['0',''].includes(withServCataId)">
                设计软件</span>
              <el-select v-model="designSoftware" size="small" ref="select"
                         v-if="!['1010698','1010699'].includes(subCatalogId)&&['2010120','2010210','2010220','2010320','2010420','1010120'].includes(subCatalogId)&&['0',''].includes(withServCataId)"
                         @change="changeSoftware" style="width: 186px;margin-left: 45px; margin-bottom: 13px;">
                <el-option label="通用" value="00"/>
                <el-option label="exocad" value="10"/>
              </el-select>
            </div>
            <div class="input-form-wrap el-input-polymerization"
                 v-if="selectDeviceData.polymerization&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>聚合度</span>
              </div>
              <input-num :style="{ '--inputColorPolymerization': colorPolymerization }"
                         @edit-num="editNumPolymerization" :num="Number(selectDeviceData.polymerization)" unit="度"
                         :step="Number(1)" :limit="Number(10)"/>
            </div>
            <div class="input-form-wrap el-input-baseHeight" v-if="selectDeviceData.baseHeight&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>基台不低于</span>
              </div>
              <input-num :style="{ '--inputColorBaseHeight': colorBaseHeight }" @edit-num="editNumBaseHeight"
                         :num="Number(selectDeviceData.baseHeight)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-shoulderWidth"
                 v-if="selectDeviceData.shoulderWidth&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台宽度</span>
              </div>
              <input-num :style="{ '--inputColorShoulderWidth': colorShoulderWidth }" @edit-num="editNumShoulderWidth"
                         :num="Number(selectDeviceData.shoulderWidth)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div class="input-form-wrap el-input-shoulderAngle"
                 v-if="selectDeviceData.shoulderAngle&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台角度</span>
              </div>
              <input-num :style="{ '--inputColorShoulderAngle': colorShoulderAngle }" @edit-num="editNumShoulderAngle"
                         :num="Number(selectDeviceData.shoulderAngle)" unit="度" :step="Number(1)"
                         :limit="Number(150)"/>
            </div>
            <div class="input-form-wrap el-select-input shoulder"
                 v-if="selectDeviceData.polymerization&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台与牙龈位置</span>
              </div>
              <el-radio class="givging" v-model="form.gingiva" label="01">龈下</el-radio>
              <el-radio class="givging" v-model="form.gingiva" label="02">齐龈</el-radio>
              <el-radio v-model="form.gingiva" label="03">龈上</el-radio>
            </div>
            <div class="input-form-wrap" style="width: 210px;margin-left: -30px;"
                 v-if="subCatalogId == '1010210' || subCatalogId == '1010220'">
              <div class="el-input-supragingival">
                <input-num v-if="form.gingiva == '01' || form.gingiva == '03'"
                           :style="{ '--inputColorSupragingival': colorSupragingival }" @edit-num="editNumSupragingival"
                           :num="Number(selectDeviceData.supragingival)" :step="Number(0.5)" :limit="Number(3)"/>
              </div>
            </div>
            <!-- 牙支持和无牙颌1010698||1010699 -->
            <div class="params-top" v-if="subCatalogId == '1010698' || subCatalogId == '1010699'">
              <div class="input-form-wrap">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>CAM制造设备名称</span>
                </div>
                <el-select class="input-select" v-model="form.deviceType" placeholder="请选择设备型号"
                           @change="changeDeviceType()" size="mini">
                  <el-option class="option-item" v-for="item in devicelists" :key="item.value" :label="item.label"
                             :value="item.value"/>
                </el-select>
                <div v-if="form.deviceType == '99'">
                  <el-input class="input-form" v-model="form.otherDeviceType" placeholder="请输入设备型号" size="mini"/>
                </div>
              </div>
            </div>
            <div>
              <div class="input-form-wrap plate-param el-input-plateThickness"
                   v-if="selectDeviceData.plateThickness || plateZero">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>导板厚度</span>
                </div>
                <input-num :style="{ '--inputColorPlateThickness': colorPlateThickness }" @edit-num="editNumThickness"
                           :num="Number(selectDeviceData.plateThickness)" :step="Number(0.005)" :limit="Number(10)"/>
              </div>
              <div class="input-form-wrap params-null-box"
                   v-if="subCatalogId == '1010698' || subCatalogId == '1010699'"></div>
              <div class="input-form-wrap plate-param el-input-teethModel"
                   v-if="selectDeviceData.teethModelDeviation || plateZero">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>牙齿/模型偏移</span>
                </div>
                <input-num :style="{ '--inputColorTeethModel': colorTeethModelDeviation }"
                           @edit-num="editNumTeethModelDeviation" :num="Number(selectDeviceData.teethModelDeviation)"
                           :step="Number(0.005)" :limit="Number(10)"/>
              </div>
              <div class="input-form-wrap plate-param el-input-recessedRetention"
                   v-if="selectDeviceData.teethModelDeviation || plateZero">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>倒凹保留量</span>
                </div>
                <input-num :style="{ '--inputColorRecessedRetention': colorRecessedRetentionAmount }"
                           @edit-num="editNumRecessedRetentionAmount"
                           :num="Number(selectDeviceData.recessedRetentionAmount)"
                           :step="Number(0.005)" :limit="Number(10)"/>
              </div>
              <div class="input-form-wrap params-null-box"
                   v-if="subCatalogId == '1010698' || subCatalogId == '1010699'"></div>
              <div class="input-form-wrap plate-param el-input-theGuideRing"
                   v-if="selectDeviceData.guideRingCompensatio || plateZero">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>从导环的补偿</span>
                </div>
                <input-num :style="{ '--inputColorTheGuideRing': colorGuideRingCompensatio }"
                           @edit-num="editNumGuideRingCompensatio" :num="Number(selectDeviceData.guideRingCompensatio)"
                           :step="Number(0.005)" :limit="Number(10)"/>
              </div>
            </div>
            <!-- </div> -->
            <div v-if="selectDeviceData.adhesiveGap&&designSoftware=='00'" class="input-form-wrap el-input-adhesivegap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>黏着剂间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdhesiveGap': colorAdhesiveGap }" @edit-num="editNumAdhesivegap"
                         :num="Number(selectDeviceData.adhesiveGap)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.adhesiveExtraGap&&designSoftware=='00'"
                 class="input-form-wrap el-input-adhesiveExtragap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>额外黏着剂间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdhesiveExtraGap': colorAdhesiveExtraGap }"
                         @edit-num="editNumAdhesiveextragap" :num="Number(selectDeviceData.adhesiveExtraGap)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.minThick&&designSoftware=='00'" class="input-form-wrap el-input-minthick">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>最小厚度</span>
              </div>
              <input-num :style="{ '--inputColorMinThick': colorMinThick }" @edit-num="editNumMinthick"
                         :num="Number(selectDeviceData.minThick)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.wallHeight&&designSoftware=='00'" class="input-form-wrap el-input-wallheight">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>壁高度</span>
              </div>
              <input-num :style="{ '--inputColorWallHeight': colorWallHeight }" @edit-num="editNumWallheight"
                         :num="Number(selectDeviceData.wallHeight)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.edgeLineDistance&&designSoftware=='00'"
                 class="input-form-wrap el-input-edgeLinedistance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>到边缘线的距离</span>
              </div>
              <input-num :style="{ '--inputColorEdgeLineDistance': colorEdgeLineDistance }"
                         @edit-num="editNumEdgelinedistance" :num="Number(selectDeviceData.edgeLineDistance)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.smoothDistance&&designSoftware=='00'"
                 class="input-form-wrap el-input-smoothdistance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>平滑距离</span>
              </div>
              <input-num :style="{ '--inputColorSmoothDistance': colorSmoothDistance }"
                         @edit-num="editNumSmoothdistance" :num="Number(selectDeviceData.smoothDistance)"
                         :step="Number(0.005)"
                         :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.burRadius&&designSoftware=='00'" class="input-form-wrap el-input-burradius">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>车针半径</span>
              </div>
              <input-num :style="{ '--inputColorBurRadius': colorBurRadius }" @edit-num="editNumBurradiusr"
                         :num="Number(selectDeviceData.burRadius)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.burGapOffset&&designSoftware=='00'"
                 class="input-form-wrap el-input-burgapoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>车针补偿间距</span>
              </div>
              <input-num :style="{ '--inputColorBurGapOffset': colorBurGapOffset }" @edit-num="editNumBurgapoffset"
                         :num="Number(selectDeviceData.burGapOffset)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.edgeLineOffset&&designSoftware=='00'"
                 class="input-form-wrap el-input-edgelineoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘线补偿</span>
              </div>
              <input-num :style="{ '--inputColorEdgeLineOffset': colorEdgeLineOffset }"
                         @edit-num="editNumEdgelineoffset" :num="Number(selectDeviceData.edgeLineOffset)"
                         :step="Number(0.005)"
                         :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.stretchOffset&&designSoftware=='00'"
                 class="input-form-wrap el-input-stretchoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>延伸补偿</span>
              </div>
              <input-num :style="{ '--inputColorStretchOffset': colorStretchOffset }" @edit-num="editNumStretchoffset"
                         :num="Number(selectDeviceData.stretchOffset)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceData.angleOffset&&designSoftware=='00'" class="input-form-wrap el-input-angleoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>补偿角度</span>
              </div>
              <input-num :style="{ '--inputColorAngleOffset': colorAngleOffset }" @edit-num="editNumAngleoffset"
                         unit="度" :num="Number(selectDeviceData.angleOffset)" :step="Number(1)" :limit="Number(90)"/>
            </div>
            <div v-if="isTonguesideShow&&designSoftware=='00'" class="input-form-wrap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>舌侧边补偿(宽度)</span>
              </div>
              <div class="input-radio">
                <div class="input-radio-box">
                  <el-radio v-model="form.isTongueSide" label="0">无</el-radio>
                  <el-radio v-model="form.isTongueSide" label="1">有</el-radio>
                </div>
              </div>
            </div>
            <div class="input-form-wrap el-select-input" v-if="form.isTongueSide == '1'&&designSoftware=='00'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>舌侧边补偿参数</span>
              </div>
              <el-select class="input-form" v-model="form.sideOffset" placeholder="请选择舌侧边补偿参数" size="mini">
                <el-option label="舌侧边" value="0"></el-option>
                <el-option label="360度边" value="1"></el-option>
              </el-select>
            </div>
            <div
              v-if="selectDeviceData.tongueSideOffset && form.isTongueSide == '1' && form.sideOffset == '0'&&designSoftware=='00'"
              class="input-form-wrap el-input-tonguesideoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>舌侧边</span>
              </div>
              <input-num :style="{ '--inputColorTongueSideOffset': colorTongueSideOffset }"
                         @edit-num="editNumTonguesideoffset" :num="Number(selectDeviceData.tongueSideOffset)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div
              v-if="selectDeviceData.circleSideOffset && form.isTongueSide == '1' && form.sideOffset == '1'&&designSoftware=='00'"
              class="input-form-wrap el-input-circlesideoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>360度边</span>
              </div>
              <input-num :style="{ '--inputColorCircleSideOffset': colorCircleSideOffset }"
                         @edit-num="editNumCirclesideoffset" :num="Number(selectDeviceData.circleSideOffset)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div
              v-if="(selectDeviceData.occlusalClearance || selectDeviceData.occlusalClearance == 0) &&
                ['1010120','1010310','1010320','2010120','2010320','2010420'].includes(subCatalogId)&&designSoftware=='00'"
              class="input-form-wrap el-input-occlusalClearance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>咬合间隙</span>
              </div>
              <input-num :style="{ '--inputColorOcclusalClearance': colorOcclusalClearance }"
                         @edit-num="editNumOcclusalClearance" :num="Number(selectDeviceData.occlusalClearance)"
                         :step="Number(0.001)" :limit="Number(10)"/>
            </div>
            <div
              v-if="(selectDeviceData.adjacencyGap || selectDeviceData.adjacencyGap == 0) &&
                ['1010120','1010310','1010320','2010120','2010320','2010420'].includes(subCatalogId)&&designSoftware=='00'"
              class="input-form-wrap el-input-adjacencyGap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>邻接间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdjacencyGap': colorAdjacencyGap }" @edit-num="editNumAdjacencyGap"
                         :num="Number(selectDeviceData.adjacencyGap)" :step="Number(0.001)" :limit="Number(10)"/>
            </div>
            <!-- add exoCad deviceParam -->
            <div class="input-form-wrap el-input-inner" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>内冠厚度</span>
              </div>
              <input-num :style="{ '--inputColorInner': colorInnerCrownThickness }"
                         @edit-num="editNum('innerCrownThickness',$event)"
                         :num="Number(selectDeviceData.innerCrownThickness)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-occlusion" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>咬合空间</span>
              </div>
              <input-num :style="{ '--inputColorOcclusion': colorOcclusionSpace }"
                         @edit-num="editNum('occlusionSpace',$event)"
                         :num="Number(selectDeviceData.occlusionSpace)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-adhesive" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>粘接剂厚度</span>
              </div>
              <input-num :style="{ '--inputColorAdhesive': colorAdhesiveThickness }"
                         @edit-num="editNum('adhesiveThickness',$event)"
                         :num="Number(selectDeviceData.adhesiveThickness)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-edge-horizontal" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘水平宽度</span>
              </div>
              <input-num :style="{ '--inputColorEdgeHorizontal': colorEdgeHorizontalWidth }"
                         @edit-num="editNum('edgeHorizontalWidth',$event)"
                         :num="Number(selectDeviceData.edgeHorizontalWidth)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-edge-tilt" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘倾斜宽度</span>
              </div>
              <input-num :style="{ '--inputColorEdgeTilt': colorEdgeTiltWidth }"
                         @edit-num="editNum('edgeTiltWidth',$event)"
                         :num="Number(selectDeviceData.edgeTiltWidth)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-edge-inclination" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘倾斜角度</span>
              </div>
              <input-num :style="{ '--inputColorEdgeInclination': colorEdgeInclinationAngle }"
                         @edit-num="editNum('edgeInclinationAngle',$event)"
                         unit="度" :num="Number(selectDeviceData.edgeInclinationAngle)" :step="Number(1)"
                         :limit="Number(90)"/>
            </div>
            <div class="input-form-wrap el-input-edge-vertical" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘垂直高度</span>
              </div>
              <input-num :style="{ '--inputColorEdgeVertical': colorEdgeVerticalHeight }"
                         @edit-num="editNum('edgeVerticalHeight',$event)"
                         :num="Number(selectDeviceData.edgeVerticalHeight)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-top" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>顶部粘接剂宽度</span>
              </div>
              <input-num :style="{ '--inputColorTop': colorTopAdhesiveWidth }"
                         @edit-num="editNum('topAdhesiveWidth',$event)"
                         :num="Number(selectDeviceData.topAdhesiveWidth)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-axial" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>轴向额外间隙</span>
              </div>
              <input-num :style="{ '--inputColorAxial': colorAxialExtraClearance }"
                         @edit-num="editNum('axialExtraClearance',$event)"
                         :num="Number(selectDeviceData.axialExtraClearance)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-extra" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>径向额外间隙</span>
              </div>
              <input-num :style="{ '--inputColorExtra': colorRadialExtraClearance }"
                         @edit-num="editNum('radialExtraClearance',$event)"
                         :num="Number(selectDeviceData.radialExtraClearance)" :step="Number(0.005)"
                         :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-sectional" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>连接杆横截面积</span>
              </div>
              <input-num :style="{ '--inputColorSectional': colorCrossSectionalAreaConnector }"
                         @edit-num="editNum('crossSectionalAreaConnector',$event)"
                         :num="Number(selectDeviceData.crossSectionalAreaConnector)" unit="mm²" :step="Number(1)"
                         :limit="Number(150)"/>
            </div>
            <div class="input-form-wrap el-input-prohibited" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>禁止填除边缘</span>
              </div>
              <input-num :style="{ '--inputColorProhibited': colorProhibitedFillingMargin }"
                         @edit-num="editNum('prohibitedFillingMargin',$event)"
                         :num="Number(selectDeviceData.prohibitedFillingMargin)" :step="Number(0.005)"
                         :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-gingival" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>牙龈厚度</span>
              </div>
              <input-num :style="{ '--inputColorGingival': colorGingivalThickness }"
                         @edit-num="editNum('gingivalThickness',$event)"
                         :num="Number(selectDeviceData.gingivalThickness)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-distance" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>到邻牙距离</span>
              </div>
              <input-num :style="{ '--inputColorDistance': colorDistanceAdjacentTooth }"
                         @edit-num="editNum('distanceAdjacentTooth',$event)"
                         :num="Number(selectDeviceData.distanceAdjacentTooth)" :step="Number(0.005)"
                         :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-margin-line" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘线下移</span>
              </div>
              <input-num :style="{ '--inputColorMarginLine': colorMarginLineShift }"
                         @edit-num="editNum('marginLineShift',$event)"
                         :num="Number(selectDeviceData.marginLineShift)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-cement" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>粘接间隙</span>
              </div>
              <input-num :style="{ '--inputColorCement': colorCementGap }" @edit-num="editNum('cementGap',$event)"
                         :num="Number(selectDeviceData.cementGap)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-from" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>从边缘线</span>
              </div>
              <input-num :style="{ '--inputColorFrom': colorFromMarginLine }"
                         @edit-num="editNum('fromMarginLine',$event)"
                         :num="Number(selectDeviceData.fromMarginLine)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-margin-cement" v-if="designSoftware=='10'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘粘接剂宽度</span>
              </div>
              <input-num :style="{ '--inputColorMarginCement': colorMarginCementWidth }"
                         @edit-num="editNum('marginCementWidth',$event)"
                         :num="Number(selectDeviceData.marginCementWidth)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>

          </div>
          <!-- 上部冠设备参数 -->
          <div class="order-input-wrap" v-if="(subCatalogId == '1010210' && withServCataId == '1010220') ||
            (subCatalogId == '1010220' && withServCataId == '1010210') ? false : true" :key="paramKey">
            <base-tag class="param-info-hat" label="上部修复冠参数信息"
                      v-if="withServCataId.includes('1010120')"></base-tag>
            <base-tag class="param-info-part" label="基台参数信息"
                      v-if="(withServCataId.includes('1010210') || withServCataId.includes('1010220')) && !withServCataId.includes('1010120')"></base-tag>
            <div class="params-top" v-if="withServCataId.includes('1010120')">
              <div class="input-form-wrap">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>CAM制造设备名称</span>
                </div>
                <el-select class="input-select" v-model="form.addeviceType" placeholder="请选择设备型号"
                           @change="changeAddeviceType" size="mini">
                  <el-option class="option-item" v-for="item in addevicelists" :key="item.value" :label="item.label"
                             :value="item.value"/>
                </el-select>
                <div v-if="form.addeviceType == '99'">
                  <el-input class="input-form" v-model="form.otherDeviceType" placeholder="请输入设备型号" size="mini"/>
                </div>
              </div>
            </div>
            <div class="input-form-wrap el-input-polymerization" v-if="selectDeviceDataInfo.polymerization">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>聚合度</span>
              </div>
              <input-num :style="{ '--inputColorPolymerization': colorPolymerization }"
                         @edit-num="editNumPolymerization" :num="Number(selectDeviceDataInfo.polymerization)" unit="度"
                         :step="Number(1)" :limit="Number(10)"/>
            </div>
            <div class="input-form-wrap el-input-baseHeight" v-if="selectDeviceDataInfo.baseHeight">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>基台不低于</span>
              </div>
              <input-num :style="{ '--inputColorBaseHeight': colorBaseHeight }" @edit-num="editNumBaseHeight"
                         :num="Number(selectDeviceDataInfo.baseHeight)" :step="Number(0.005)" :limit="Number(13)"/>
            </div>
            <div class="input-form-wrap el-input-shoulderWidth" v-if="selectDeviceDataInfo.shoulderWidth">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台宽度</span>
              </div>
              <input-num :style="{ '--inputColorShoulderWidth': colorShoulderWidth }" @edit-num="editNumShoulderWidth"
                         :num="Number(selectDeviceDataInfo.shoulderWidth)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div class="input-form-wrap el-input-shoulderAngle" v-if="selectDeviceDataInfo.shoulderAngle">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台角度</span>
              </div>
              <input-num :style="{ '--inputColorShoulderAngle': colorShoulderAngle }" @edit-num="editNumShoulderAngle"
                         :num="Number(selectDeviceDataInfo.shoulderAngle)" unit="度" :step="Number(1)"
                         :limit="Number(150)"/>
            </div>
            <div class="input-form-wrap el-select-input shoulder" v-if="selectDeviceDataInfo.polymerization">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>肩台与牙龈位置</span>
              </div>
              <el-radio class="givging" v-model="form.gingiva" label="01">龈下</el-radio>
              <el-radio class="givging" v-model="form.gingiva" label="02">齐龈</el-radio>
              <el-radio v-model="form.gingiva" label="03">龈上</el-radio>
            </div>
            <div class="input-form-wrap" style="width: 210px;margin-left: -30px;"
                 v-if="(withServCataId.includes('1010210') || withServCataId.includes('1010220')) && !withServCataId.includes('1010120')">
              <div class="el-input-supragingival">
                <input-num v-if="form.gingiva == '01' || form.gingiva == '03'"
                           :style="{ '--inputColorSupragingival': colorSupragingival }" @edit-num="editNumSupragingival"
                           :num="Number(selectDeviceDataInfo.supragingival)" :step="Number(0.5)" :limit="Number(3)"/>
              </div>
            </div>
            <div v-if="selectDeviceDataInfo.adhesiveGap" class="input-form-wrap el-input-adhesivegap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>黏着剂间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdhesiveGap': colorAdhesiveGap }" @edit-num="editNumAdhesivegap"
                         :num="Number(selectDeviceDataInfo.adhesiveGap)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.adhesiveExtraGap" class="input-form-wrap el-input-adhesiveExtragap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>额外黏着剂间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdhesiveExtraGap': colorAdhesiveExtraGap }"
                         @edit-num="editNumAdhesiveextragap" :num="Number(selectDeviceDataInfo.adhesiveExtraGap)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.minThick" class="input-form-wrap el-input-minthick">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>最小厚度</span>
              </div>
              <input-num :style="{ '--inputColorMinThick': colorMinThick }" @edit-num="editNumMinthick"
                         :num="Number(selectDeviceDataInfo.minThick)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.wallHeight" class="input-form-wrap el-input-wallheight">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>壁高度</span>
              </div>
              <input-num :style="{ '--inputColorWallHeight': colorWallHeight }" @edit-num="editNumWallheight"
                         :num="Number(selectDeviceDataInfo.wallHeight)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.edgeLineDistance" class="input-form-wrap el-input-edgeLinedistance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>到边缘线的距离</span>
              </div>
              <input-num :style="{ '--inputColorEdgeLineDistance': colorEdgeLineDistance }"
                         @edit-num="editNumEdgelinedistance" :num="Number(selectDeviceDataInfo.edgeLineDistance)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.smoothDistance" class="input-form-wrap el-input-smoothdistance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>平滑距离</span>
              </div>
              <input-num :style="{ '--inputColorSmoothDistance': colorSmoothDistance }"
                         @edit-num="editNumSmoothdistance" :num="Number(selectDeviceDataInfo.smoothDistance)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.burRadius" class="input-form-wrap el-input-burradius">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>车针半径</span>
              </div>
              <input-num :style="{ '--inputColorBurRadius': colorBurRadius }" @edit-num="editNumBurradiusr"
                         :num="Number(selectDeviceDataInfo.burRadius)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.burGapOffset" class="input-form-wrap el-input-burgapoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>车针补偿间距</span>
              </div>
              <input-num :style="{ '--inputColorBurGapOffset': colorBurGapOffset }" @edit-num="editNumBurgapoffset"
                         :num="Number(selectDeviceDataInfo.burGapOffset)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.edgeLineOffset" class="input-form-wrap el-input-edgelineoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>边缘线补偿</span>
              </div>
              <input-num :style="{ '--inputColorEdgeLineOffset': colorEdgeLineOffset }"
                         @edit-num="editNumEdgelineoffset" :num="Number(selectDeviceDataInfo.edgeLineOffset)"
                         :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.stretchOffset" class="input-form-wrap el-input-stretchoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>延伸补偿</span>
              </div>
              <input-num :style="{ '--inputColorStretchOffset': colorStretchOffset }" @edit-num="editNumStretchoffset"
                         :num="Number(selectDeviceDataInfo.stretchOffset)" :step="Number(0.005)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.angleOffset" class="input-form-wrap el-input-angleoffset">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>补偿角度</span>
              </div>
              <input-num :style="{ '--inputColorAngleOffset': colorAngleOffset }" @edit-num="editNumAngleoffset"
                         unit="度" :num="Number(selectDeviceDataInfo.angleOffset)" :step="Number(1)"
                         :limit="Number(90)"/>
            </div>
            <div v-if="selectDeviceDataInfo.occlusalClearance" class="input-form-wrap el-input-occlusalClearance">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>咬合间隙</span>
              </div>
              <input-num :style="{ '--inputColorOcclusalClearance': colorOcclusalClearance }"
                         @edit-num="editNumOcclusalClearance" :num="Number(selectDeviceDataInfo.occlusalClearance)"
                         :step="Number(0.001)" :limit="Number(10)"/>
            </div>
            <div v-if="selectDeviceDataInfo.adjacencyGap" class="input-form-wrap el-input-adjacencyGap">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>邻接间隙</span>
              </div>
              <input-num :style="{ '--inputColorAdjacencyGap': colorAdjacencyGap }" @edit-num="editNumAdjacencyGap"
                         :num="Number(selectDeviceDataInfo.adjacencyGap)" :step="Number(0.001)" :limit="Number(10)"/>
            </div>
          </div>
          <!-- 口扫数据 -->
          <div class="input-upload-wrap" v-if="common.serv.get(subCatalogId).isScanData == '1'">
            <base-tag label="口扫数据" v-if="this.subCatalogId != '1010410'"></base-tag>
            <base-tag label="扫描数据" v-else></base-tag>
            <div v-if="subCatalogId == '1010698' || subCatalogId == '1010700'">
              <span class="tip-btn1" @click="changeOralDis">查看示例</span>
              <div class="order-upload-wrap">
                <div class="order-file-wrap">
                  <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                             :before-remove="beforeRemove"
                             :on-remove="(file, fileList) => { handleRemove(file, fileList, '07') }"
                             :data="{ objectType: '07', objectTag: subCatalogId + '_' + form.demPatient }"
                             :file-list="dataScan"
                             :on-exceed="handleExceed" :auto-upload="true" :limit="5" multiple :disabled="oralUpload">
                    <div class="upload-file-dragger1" @click="oralTip">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="order-upload-wrap" v-else>
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                           :before-remove="beforeRemove"
                           :on-remove="(file, fileList) => { handleRemove(file, fileList, '07') }"
                           :data="{ objectType: '07', objectTag: subCatalogId + '_' + form.demPatient }"
                           :file-list="dataScan"
                           :on-exceed="handleExceed" :auto-upload="true" :limit="5" multiple>
                  <div class="upload-file-dragger1">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 设计单照片 -->
          <!-- <div class="input-upload-wrap" v-if="common.serv.get(subCatalogId).isSheetData == '1'">
            <base-tag label="设计单照片"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-image-wrap">
                <el-upload class="upload-demp" action :before-upload="beforeUpload" :http-request="uploadFile"
                  :data="{ objectType: '08', objectTag: subCatalogId + '_' + form.demPatient }" :on-preview="handlePreview"
                  :before-remove="beforeRemove" :on-remove="(file, fileList) => { handleRemove(file, fileList, '08') }"
                  :on-exceed="handleExceed" :auto-upload="true" :limit="3" list-type="picture-card" multiple>
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div> -->
          <!-- 口内照片 -->
          <div class="input-upload-wrap" v-if="common.serv.get(subCatalogId).isMouthData == '1'">
            <base-tag label="口内照片"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-image-wrap">
                <el-upload class="upload-demp" action :before-upload="beforeUpload" :http-request="uploadFile"
                           :data="{ objectType: '09', objectTag: subCatalogId + '_' + form.demPatient }"
                           :on-preview="handlePreview" :before-remove="beforeRemove"
                           :on-remove="(file, fileList) => { handleRemove(file, fileList, '09') }"
                           :on-exceed="handleExceed"
                           :auto-upload="true" :limit="6" list-type="picture-card" multiple>
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- CBCT数据 -->
          <div class="input-upload-wrap"
               v-if="common.serv.get(subCatalogId).isCbctData == '1' && (subCatalogId == '1010698' || subCatalogId == '1010699')">
            <span :class="subCatalogId == '1010699' ? 'tip-btn3' : 'tip-btn2'" @click="changeCBCTDis"
                  v-if="subCatalogId == '1010698'">查看示例</span>
            <span :class="subCatalogId == '1010699' ? 'tip-btn3' : 'tip-btn2'" @click="changeCBCTDis1"
                  v-else>查看示例</span>
            <span :class="fileNum > 0 ? 'load-advice-file' : 'load-advice'"
                  v-show="dataCbct.length<=0">提示：大于100MBCBCT文件上传时间较长，请耐心等待，建议使用较快本地网络进行操作。</span>
            <base-tag label="CBCT数据" v-if="subCatalogId == '1010698'"></base-tag>
            <base-tag label="上传患者佩戴放射导板的CBCT数据文件 (DICOM格式)"
                      v-if="subCatalogId == '1010699'"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                           :before-remove="beforeRemove"
                           :on-remove="(file, fileList) => { handleRemove(file, fileList, '10') }"
                           :data="{ objectType: '10', objectTag: subCatalogId + '_' + form.demPatient }"
                           :file-list="dataCbct"
                           :on-exceed="handleExceed" :auto-upload="true" :limit="6" multiple
                           :disabled="subCatalogId == '1010698' ? CBCTUpload : CBCTUpload1">
                  <div class="upload-file-dragger1" @click="CBCT1Tip()" v-if="subCatalogId == '1010698'">
                    <i class="el-icon-plus"></i>
                  </div>
                  <div class="upload-file-dragger1" @click="CBCT2Tip()" v-else>
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="input-upload-wrap"
               v-if="common.serv.get(subCatalogId).isCbctData == '1' && subCatalogId == '1010699'">
            <span class="tip-btn4" @click="changeCBCTDis2">查看示例</span>
            <span :class="fileNum > 0 ? 'load-advice-file' : 'load-advice'" v-show="dataSheet.length<=0">
              提示：大于100MBCBCT文件上传时间较长，请耐心等待，建议使用较快本地网络进行操作。
            </span>
            <base-tag label="上传放射导板CBCT数据（DICOM格式）"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                           :before-remove="beforeRemove"
                           :on-remove="(file, fileList) => { handleRemove(file, fileList, '08') }"
                           :data="{ objectType: '08', objectTag: subCatalogId + '_' + form.demPatient }"
                           :file-list="dataSheet"
                           :on-exceed="handleExceed" :auto-upload="true" :limit="6" multiple :disabled="CBCTUpload2">
                  <div class="upload-file-dragger1" @click="CBCT3Tip()">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 扫描杆数据库 -->
          <div class="input-upload-wrap"
               v-if="['1010210','1010220','1010310','1010320','1010410','1010510'].includes(subCatalogId)||['1010210','1010220'].includes(withServCataId)">
            <base-tag label="扫描杆和替代体数据库"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                           :before-remove="beforeRemove"
                           :on-remove="(file, fileList) => { handleRemove(file, fileList, '21') }"
                           :data="{ objectType: '21', objectTag: subCatalogId + '_' + form.demPatient }"
                           :file-list="dataScanRod"
                           :on-exceed="handleExceed" :auto-upload="true" :limit="5" multiple>
                  <div class="upload-file-dragger1">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <FileHistory @push-data="handleFileList" :dataField="'dataScanRod'"
                       v-if="['1010210','1010220','1010310','1010320','1010410','1010510'].includes(subCatalogId)||['1010210','1010220'].includes(withServCataId)"/>
          <el-dialog :visible.sync="dialogVisible">
            <img width="70%" :src="dialogImageUrl" alt/>
          </el-dialog>
        </div>
      </div>
      <div class="order-ops">
        <y-button text="重新创建" classStyle="main-btn ml" @btnClick="clickReSelect"
                  v-if="currentStep === 2"></y-button>
        <y-button text="上一步" classStyle="main-btn ml" @btnClick="clickPreStep" v-if="currentStep === 3"></y-button>
        <y-button text="下一步" :classStyle="nextStep ? 'main-btn ml' : 'disabled-btn ml'" @btnClick="clickNextStep"
                  v-if="currentStep != 3"></y-button>
        <y-button :text="isEditServOrder == '1' ? '修改提交' : '生成订单'"
                  :classStyle="isSubmitting ? 'disabled-btn ml' : 'main-btn ml'"
                  @btnClick="submitUpdate" v-if="isEditServOrder == '1' || currentStep == 3"></y-button>
      </div>
    </el-card>
    <Customer class="customerSer"></Customer>
    <el-dialog center title="进度留言" width="30%" :visible.sync="msgDialog" :modal-append-to-body="false"
               :destroy-on-close="true" :lock-scroll="false">
      <el-form label-position="left" :model="ruleForm" ref="ruleForm">
        <el-form-item prop="content" label="留言内容:" label-width="120px">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="ruleForm.content"
                    placeholder="请填写留言内容内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="msgDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">继续制作</el-button>
      </div>
    </el-dialog>
    <!-- create参数模版dialog -->
    <el-dialog :title="isEditTemplate == '0' ? '创建模版' : '编辑模版'" width="60%" :visible.sync="templateDialog"
               :modal-append-to-body="false" :destroy-on-close="true" :close-on-click-modal="false">
      <paramTemplate :isDevicelistShow="showDeviceList" :form="form" :devicelists="devicelists"
                     :camParamList="camParamList"
                     :selectDeviceData="selectDeviceData" :subCatalogId="subCatalogId"
                     :isTonguesideShow="isTonguesideShow"
                     :plateZero="plateZero" :datalists="datalists" :key="templateDialog"
                     :isEditTemplate="isEditTemplate"
                     @changeDialog="changeDialog" @changeDeviceType="changeDeviceType"
                     :editDeviceParam="editDeviceParam">
      </paramTemplate>
    </el-dialog>
    <!-- 提示窗口口扫 -->
    <el-dialog title="提示" :visible.sync="dialogStatue" width="40%" :modal-append-to-body="false" center>
      <div class="promptWin">
        <ul class="dialog-ul" v-if="subCatalogId == '1010698' || subCatalogId == '1010699'">
          <li style="text-align: center;margin-bottom: 30px;">
            注：请确认上传的扫描数据具有稳定上下颌咬合关系的全口数字印模，如图参考
          </li>
          <li>
            <img src="/static/images/yaohe.png">
            <p class="advice adv-txt">咬合</p>
          </li>
          <li>
            <img src="/static/images/shanghe.png">
            <p class="advice adv-txt">上颌</p>
          </li>
          <li>
            <img src="/static/images/xiahe.png">
            <p class="advice adv-txt">下颌</p>
          </li>
        </ul>
        <ul class="dialog-ul" v-else-if="subCatalogId == '1010700'">
          <li style="width: 520px;margin-bottom: 10px;">
            注：按覆盖义齿获取上，下颌全口信息数据，建议传统口内硅胶取模，翻制石膏模型后进行椅旁数字化扫描，上传数字化文件
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 提示窗口CBCT -->
    <el-dialog title="提示" :visible.sync="CBCTdialog" width="40%" :modal-append-to-body="false" center>
      <div class="promptWin">
        <ul class="dialog-ul">
          <li>
            <p class="advice-CBCT">
              a.请确保数据无断层，重要组织解剖结构，如上颌窦，神经管等清晰可见，无伪影，开牙合拍摄，如图参考</p>
            <img src="/static/images/CBCT1.png">
          </li>
          <li>
            <p class="advice-CBCT">b.CBCT导出层厚不宜过大，建议层厚＜0.3mm,如图参考</p>
            <img src="/static/images/CBCT2.png">
          </li>
          <li>
            <p class="advice-CBCT">c. CBCT视野不小于8*8cm，工作侧拍摄清晰，如图参考</p>
            <img src="/static/images/CBCT3.png">
          </li>
          <li>
            <p class="advice-CBCT">d．若口内存在大量不可摘修复体，需要先制作放射导板，并拍摄患者佩戴放射导板的CBCT数据</p>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 提示窗口CBCT1 -->
    <el-dialog title="提示" :visible.sync="CBCTdialog1" width="40%" :modal-append-to-body="false" center>
      <div class="promptWin">
        <p class="prompt" style="text-align: center;font-size: 16px;color:black;">
          注：患者佩戴咬合记录和放射导板拍摄CBCT,确认放射导板就位密贴。</p>
        <ul class="dialog-ul">
          <li>
            <img src="/static/images/order/catalog_adv/occlusion.png">
            <p class="advice adv-txt">口内佩戴咬合记录和放射导板</p>
          </li>
          <li>
            <img src="/static/images/order/catalog_adv/radiate.png">
            <p class="advice adv-txt">拍摄佩戴放射导板的CBCT</p>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 提示窗口CBCT2 -->
    <el-dialog title="提示" :visible.sync="CBCTdialog2" width="40%" :modal-append-to-body="false" center>
      <div class="promptWin">
        <p class="prompt" style="text-align: center;font-size: 16px;color:black;">
          注：上颌放射导板组织面朝上拍摄，下颌放射导板咬合面朝上拍摄。</p>
        <ul class="dialog-ul">
          <li>
            <img src="/static/images/order/catalog_adv/upperRadiate.png">
            <p class="advice adv-txt">上颌放射导板</p>
          </li>
          <li>
            <img src="/static/images/order/catalog_adv/lowerRadiate.png">
            <p class="advice adv-txt">下颌放射导板</p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import {
  getStore
} from '/utils/storage'
// 局部引入
import EleUploadImage from "vue-ele-upload-image";

import YButton from '/components/YButton'
import YTooth from '/components/YTooth'
import BaseTag from '/components/BaseTag'
import InputNum from '/components/inputNum'
import BuyNum from '/components/buynum'
import Customer from './components/customerSer.vue'
import paramTemplate from './components/paramTemplate.vue'
import CanvasTooth from '../../components/canvasTooth.vue';
import InputField from './components/orderCreate/InputField.vue';
import SelectField from './components/orderCreate/SelectField.vue';
import orthodontics from './orthodonticsOrder/orthodonticsCreateOrder';
import InputNumberField from './components/orderCreate/InputNumberField.vue';
import RadioField from './components/orderCreate/RadioField.vue';
import SelIndication from './components/orderCreate/CompositeIndication/selIndication';
import ImpSys from './components/orderCreate/CompositeIndication/impSystem';
import FileHistory from '/components/fileHistory';

import orderList from "/assets/config/order/orderList.js";
import catalogList from "/assets/config/order/catalogList.js";
import navDemList from "/assets/config/navDemList.js";
import navDesList from "/assets/config/navDesList.js";
import navListDefault from "/assets/config/navList.js";
import {
  uploadByPieces
} from "../../../common/upload.js";
import graceChecker from '../../../common/graceChecker.js';
import {
  array
} from 'js-md5';

export default {
  data() {
    return {
      //动态改变文字颜色
      colorContact: '',
      colorPhone: '',
      colorPatient: '',
      colorOrderCount: '',
      colorOrderAmount: '',
      colorAdhesiveGap: '', //黏着剂间隙
      colorAdhesiveExtraGap: '', //额外黏着剂间隙
      colorMinThick: '', //最小厚度
      colorWallHeight: '', //壁高度
      colorEdgeLineDistance: '', //到边缘线的距离
      colorSmoothDistance: '', //平滑距离
      colorBurRadius: '', //车针半径
      colorBurGapOffset: '', //车针补偿间距
      colorEdgeLineOffset: '', //边缘线补偿
      colorStretchOffset: '', //延伸补偿
      colorAngleOffset: '', //补偿角度
      colorOcclusalClearance: '', //咬合间隙
      colorAdjacencyGap: '', //邻接间隙
      colorTongueSideOffset: '', //舌侧边
      colorCircleSideOffset: '', //360度边
      colorPlateThickness: '', //导板厚度
      colorTeethModelDeviation: '', //牙齿/模型偏移
      colorRecessedRetentionAmount: '', //倒凹保留量
      colorGuideRingCompensatio: '', //从导环的补偿
      colorPolymerization: '', //聚合度
      colorBaseHeight: '', //基台高度
      colorShoulderWidth: '', //肩台宽度
      colorShoulderAngle: '', //肩台角度
      colorSupragingival: '', //龈上参数
      // exo设计参数
      colorInnerCrownThickness: '',
      colorOcclusionSpace: '',
      colorAdhesiveThickness: '',
      colorEdgeHorizontalWidth: '',
      colorEdgeTiltWidth: '',
      colorEdgeInclinationAngle: '',
      colorEdgeVerticalHeight: '',
      colorTopAdhesiveWidth: '',
      colorAxialExtraClearance: '',
      colorRadialExtraClearance: '',
      colorCrossSectionalAreaConnector: '',
      colorProhibitedFillingMargin: '',
      colorGingivalThickness: '',
      colorDistanceAdjacentTooth: '',
      colorMarginLineShift: '',
      colorCementGap: '',
      colorFromMarginLine: '',
      colorMarginCementWidth: '',

      userId: '',
      loading: true,
      currentStep: 1,
      nextStep: false,
      datalists: [], //等于主类和子类的所有数据
      devicelists: [], //组合设备列表加载下拉框
      addatalists: [], //等于主类和子类的所有数据
      addevicelists: [], //组合设备列表加载下拉框
      selectDeviceDataInfo: '', //选中的设备对应信息参数(额外适应症)
      selectDeviceData: '', //选中的设备对应信息参数
      isTonguesideShow: false, //是否显示舌侧边补偿
      stepList: [{
        "step": 1,
        "name": "服务选择",
        "status": -1,
        "icon": "el-icon-thumb"
      },
        {
          "step": 2,
          "name": "设计信息",
          "status": 0,
          "icon": "el-icon-edit"
        },
        {
          "step": 3,
          "name": "数据上传",
          "status": 0,
          "icon": "el-icon-upload"
        }
      ],
      currentCatalog: -1,
      currentSubCatalog: -1,
      catalogList: [],
      subCatalogList: [],
      catalogId: '',
      subCatalogId: '',
      catalogTitle: '',
      upperZero: false,
      plateZero: false,
      editModelFee: 0.00,
      form: {
        /** 发单方诊所/工厂名称 */
        demName: '',
        /** 发单方联系人 */
        demContact: '',
        /** 发单方联系方式 */
        demPhone: '',
        /** 患者名称 */
        demPatient: '',
        /** 设计师等级 01=初级,02=中级,03=高级,99=认证级 */
        desLevel: '',
        /** 数量 */
        orderCount: 0,
        toothCountAll: 0,//牙位总数
        /** 单价 */
        orderPrice: 0.00,
        /** 是否加急 0=否,1=是 */
        /** 加急费 */
        orderRushFee: 0.00,
        /** 订单总价 */
        orderAmount: 0.00,
        /** 订单备注 */
        orderRemark: '',
        /** 软件种类 */
        softType: '',
        otherSoftType: '',
        /** 数据类型 */
        dataType: '',
        otherDataType: '',
        /** 牙位-单冠 */
        posSingle: '',
        /** 牙位-连桥 */
        posBridge: '',
        /** 冠部开孔牙位 */
        posHole: '0',
        /** 导板类型 01=全程导板,02=半程导板,03=先锋钻导板 */
        plateType: '',
        /** 植体系统 */
        impSystem: '',
        /** 植体型号 */
        impModel: '',
        /** 植体系统（其他） impSystem = 99*/
        impExtra: '',
        // 是否编辑模型文件
        isEditScanModel: '0',
        /** 扫描杆供应商 */
        scanningRod: '',
        scanningRodSupplier: '',
        surgicalBoxSupplier: '',
        plantModel: '',
        /** 开孔直径 */
        holeDiameter: 2.5,
        /** 修复体材质 */
        repairMaterial: '',
        /** 设备型号 */
        deviceType: '',
        otherDeviceType: '',
        addeviceType: '',
        adotherDeviceType: '',
        /** 桥架上部修复工艺 01=氧化锆冠粘贴工艺,02=树脂排牙工艺 */
        briCraft: '',
        /* 杆卡类型*/
        collar: '',
        /** 舌侧金属边 0=否,1=是 */
        demSex: '',
        /* 肩台与牙龈位置 */
        shoulderPosition: '01',
        /* 编辑模型文件是否0/1*/
        adhesiveGap: 0.03, //黏着剂间隙
        adhesiveExtraGap: 0.04, //额外黏着剂间隙：0.04mm
        minThick: 0.6, //最小厚度：0.6mm
        wallHeight: 0.8, //壁高度：0.8mm
        edgeLineDistance: 1, //到边缘线的距离：1mm
        smoothDistance: 0.2, //平滑距离: 0.2mm
        burRadius: 0.5, //车针半径 : 0.5mm
        burGapOffset: 0.52, //车针补偿间距: 0.52mm
        edgeLineOffset: 0.15, //边缘线补偿: 0.15mm
        stretchOffset: 0.1, //延伸补偿:0.1mm
        angleOffset: 60, //补偿角度:25-60度
        isTongueSide: '0', //舌侧边补偿（宽度）0=无,1=有
        sideOffset: '0', //默认舌侧边
        tongueSideOffset: 1, //舌侧边 1mm
        circleSideOffset: 1, //360度边1mm
        plateThickness: 2, //导板厚度: 2~2.5mm
        teethModelDeviation: 0.05, //牙齿/模型偏移0.05mm
        recessedRetentionAmount: 0, //倒凹保留量 0
        guideRingCompensatio: 0.05, //从导环的补偿 0.05mm
        polymerization: 6, //聚合度 默认6度，-15~15度
        baseHeight: 4.5, //基台高度 4.5mm 2~13mm
        shoulderWidth: 1, //肩台宽度 1mm 0.5~1mm
        shoulderAngle: 120, //肩台角度 120度 90~165度
        gingiva: '01', //牙龈位置
        supragingival: 1.0, //龈下参数
        subgingival: '', //精密附件供应商及型号
        occlusalClearance: 0.025, //咬合间隙0.025mm
        adjacencyGap: -0.08, //邻接间隙-0.08mm
        // exo参数
        innerCrownThickness: 0,
        occlusionSpace: 0,
        adhesiveThickness: 0,
        axialExtraClearance: 0,
        edgeHorizontalWidth: 0,
        edgeTiltWidth: 0,
        edgeInclinationAngle: 0,
        edgeVerticalHeight: 0,
        topAdhesiveWidth: 0,
        radialExtraClearance: 0,
        crossSectionalAreaConnector: 0,
        prohibitedFillingMargin: 0,
        gingivalThickness: 0,
        distanceAdjacentTooth: 0,
        marginLineShift: 0,
        cementGap: 0,
        fromMarginLine: 0,
        marginCementWidth: 0,
      },
      // 留言表单
      ruleForm: {
        content: ''
      },
      isEditServOrder: '0', //新增订单or修改订单
      dialogImageUrl: "", //dialog图片路径
      dialogVisible: false,
      formData: "",
      /** 口扫数据 */
      dataScan: [],
      /** 设计单照片 */
      dataSheet: [],
      /** 口内照片 */
      dataMouth: [],
      /** CBCT数据 */
      dataCbct: [],
      dataScanRod: [],
      fileList: [],
      singleDataList: [],
      bridgeDataList: [],
      cateserv: null, // 服务单参数详情
      dialogStatue: false, //提交文件提示弹窗
      CBCTdialog: false, //CBCTdialog控制
      CBCTdialog1: false, //CBCTdialog控制
      CBCTdialog2: false, //CBCTdialog控制
      dialogNum: 0,
      CBCTNum: 0, //查看dialog次数
      CBCTNum1: 0, //查看dialog次数
      CBCTNum2: 0, //查看dialog次数
      oralUpload: true,
      CBCTUpload: true,
      CBCTUpload1: true,
      CBCTUpload2: true,
      impSystemList: [], //植体型号
      impModelList: [], //植体型号
      impModelListTemp: [], //筛选的植体型号
      fileNum: 0, //上传文件数量
      prohibit: false,
      selectFileCount: 0,
      successFileCount: 0,
      metal: [],//选择牙位存储基台金属(黑)
      metal2: [],//选择牙位存储基台全瓷(绿)
      extraUnitPrice: 0.00, //额外适应症基台/上部冠单价
      quantity: 0, //额外适应症基台/上部冠数量
      flagBridge: false, //牙位连桥状态
      upSelect: '', //选择上颌
      downSelect: '', //选择下颌
      metalUp: '', //额外适应症牙位上选择数量
      metalDown: '', //额外适应症牙位下选择数量
      servBridge: false, //tooth组件是否显示切换单冠连桥
      withServCataId: '', //额外适应症di
      basePrice: 0, //额外适应症单价
      fund: 0, //额外适应症基台数量
      montageStr: '', //复合适应症拼接牙位的存储字段，在submit方法传个posingle
      desLevelMap: [], //工厂端设计师等级
      composite: '', //判断是否显示组合适应症
      options1: false,
      options2: false,
      options3: false,
      levelIf: false, //判断设计师级别类名
      countIf: false, //判断类名及显示
      calIf: false, //判断类名及显示
      tempList2: [], //tooth组件活动牙位选中列表
      remarkHistory: [], //备注历史列表
      templateDialog: false, //生成模版的dialog
      isEditTemplate: '0',
      // header
      templateItem: '9999',
      templateOptions: [],
      editDeviceParam: '', //获取的对应模版
      editFormParam: '', //修改进入form设备参数
      renovate: true, //主服务类设备参数key
      paramKey: 0, //复合适应症设备参数key
      isShowTemplate: true, //显示模版选项
      // 动态类名
      countClass: '',
      priceClass: '',
      rushClass: '',
      totalPriceClass: '',
      upperCountClass: '',
      upperPriceClass: '',
      msgDialog: false, //修改订单留言框status
      isCreate: false, //创建订单的状态还是修改订单的状态，传递给tooth组件
      camParamList: [], //cam参数list
      designSoftware: '00',//软件类型
      isSubmitting: false, //生成订单节流延时
      demSexMap: [{
        value: '00',
        label: '男'
      },
        {
          value: '01',
          label: '女'
        }
      ],
    }
  },
  computed: {
    ...mapState(['common', 'user']),
    editScanModelText() {
      const price = this.common.serv.get(this.subCatalogId).editScanModelBprice || 0;
      return `编辑模型文件${price}元`;
      ;
    },
    rowFactory() {
      const id = this.subCatalogId;
      // 门诊/工厂 显示四/五列
      if (this.user.demServType != '00') {
        return false;
      }

      if (['1010210', '1010220'].includes(this.subCatalogId) && this.options1 == true) {
        return false;
      }

      // 对于特定服务类型，根据条件判断是否显示五列
      if (['1010210', '1010220'].includes(id)) {
        // 当 quantity 或 fund 大于0时，不显示五列
        return !(this.quantity > 0 || this.fund > 0);
      }
      if (id === '1010120') {
        // 当 options2 或 options3 为 true 时，不显示五列
        if (this.options2 || this.options3) {
          return false;
        }
        // 当 quantity 为 0 时，显示五列
        return this.quantity === 0;
      }
      // 对于其他指定服务类型，默认显示五列
      const arr = ['1010120', '1010310', '1010320'];
      return arr.includes(id);
    },
    // 复合适应症的 单价/数量
    showUpperCrownInfo() {
      const {subCatalogId, options1, options2, options3, quantity} = this
      const isBaseAbutment = ['1010120'].includes(subCatalogId) && (options2 || options3)
      const isUpperCrown = ['1010210', '1010220'].includes(subCatalogId) && options1
      const isMalongBridge = ['1010410'].includes(subCatalogId) && (options1 || quantity)
      return isBaseAbutment || isUpperCrown || isMalongBridge
    },
    // 显示设计师级别
    showLevel() {
      const id = this.subCatalogId;
      return this.user.demServType == '00' &&
        (['1010120', '1010210', '1010220', '1010310', '1010320',
            '2010120', '2010210', '2010220', '2010320', '2010420'].includes(id) ||
          ['1010410'].includes(id) && (this.options1 || this.quantity))
    },
    // 显示设备下拉列表
    showDeviceList() {
      let id = this.subCatalogId;
      return !['2010210', '1010210', '1010220', '1010310', '1010320', '1010510'].includes(id) ||
        (['1010410'].includes(id) && this.withServCataId == '1010120')
    },
    // 显示设计信息
    showDesignReq() {
      const {subCatalogId, quantity, options1} = this
      const isDesignInfo = subCatalogId === '1010120'
      const isMalongBridge = subCatalogId === '1010410' && (options1 || quantity)
      return isDesignInfo || isMalongBridge
    },
    // 显示冠部是否开孔
    showHole() {
      const {subCatalogId, quantity, options1} = this
      const isBaseHole = this.common.serv.get(subCatalogId) &&
        this.common.serv.get(subCatalogId).isHole == '1'
      const isMalongBridge = subCatalogId == '1010410' && (options1 || quantity)
      return isBaseHole || isMalongBridge
    },
    currentNavSubList() {
      var navList = [];
      switch (this.user.userType) {
        case "10":
          navList = navDemList;
          break;
        case "20":
          navList = navDesList;
          break;
        default:
          navList = navListDefault;
          break;
      }
      var idx = this.common.navSelect.navIndex;
      if (idx >= 0 && navList[idx] && navList[idx].navSubList) {
        return navList[idx].navSubList;
      }
      return [];
    },
  },
  methods: {
    onSubNavChange(val) {
      const sub = this.currentNavSubList[val];
      if (!sub) return;
      if (sub.linkType === 1) {
        this.$yxz.to('/' + sub.linkUrl);
      } else if (sub.linkType === 2) {
        var url = '//' + window.location.host + '/#/' + sub.linkUrl;
        if (sub.query) {
          var qs = [];
          for (var k in sub.query) {
            qs.push(k + '=' + sub.query[k]);
          }
          if (qs.length > 0) url += '?' + qs.join('&');
        }
        window.open(url);
      } else if (sub.linkType === 9) {
        this.$router.push({path: "/" + sub.linkUrl, query: sub.query});
      } else {
        window.open(sub.linkUrl);
      }
    },
    // 切换模版
    changeTemplate() {
      this.selectDeviceData = {}
      if (this.templateItem != '9999') {
        this.$api.get({
          url: '/business/template/' + this.templateItem
        }).then(res => {
          // 获取已删除的数据项，赋值默认值
          if (!res.data) {
            this.templateItem = '9999'
            sessionStorage.setItem('templateItem', this.templateItem)
            return false
          }
          if (!['', '0'].includes(this.withServCataId) && res.data.designSoftware == '10') {
            this.templateItem = '9999'
            sessionStorage.setItem('templateItem', this.templateItem)
            this.$yxz.msg('复合适应症暂不支持包含exocad参数模版', 'info')
            return false
          }
          this.selectDeviceData = res.data
          this.form.deviceType = res.data.deviceType
          this.designSoftware = res.data.designSoftware
          this.form.isTongueSide = res.data.isTongueSide ? res.data.isTongueSide : '0'
          this.form.gingiva = res.data.gingiva ? res.data.gingiva : '01'
          sessionStorage.setItem('selectDeviceData', JSON.stringify(this.selectDeviceData))
          if (res.data.deviceType == '99') {
            this.form.otherDeviceType = res.data.otherDeviceType
          }
          this.changeDeviceType()
        })
      } else {
        this.form.deviceType = ''
        this.designSoftware = '00'
        this.getDeviceInfo()
      }
      sessionStorage.setItem('templateItem', this.templateItem)
    },
    // 移除模版项
    removeTemplateItem(id) {
      let temp = []
      temp.push(id + '')
      this.$api.get({
        url: '/business/template/delete/' + temp
      }).then(res => {
        if (res.code == 200) {
          this.$yxz.msg(res.msg, 'success')
          this.changeDialog(false, '0')
          this.templateItem = '9999'
          this.$nextTick(() => {
            this.templateItem = '9999'
            this.getTemplateList()
          })
        } else {
          this.$yxz.msg(res.msg);
        }
      })
    },
    // 编辑模版项
    updateItem(id) {
      this.$api.get({
        url: '/business/template/' + id
      }).then(res => {
        this.editDeviceParam = res.data
        this.templateDialog = true
        this.isEditTemplate = '1'
      })
    },
    // 改变显示连桥状态
    sendBridge(bridge) {
      var id = this.subCatalogId
      if (!['1010698', '1010699', '1010700', '1010410'].includes(id)) {
        this.flagBridge = bridge
      }
    },
    // tooth组件传值判断单双颌
    judgeJaw(upSelectCount, downSelectCount, metalUp, metalDown) {
      this.upSelect = upSelectCount
      this.downSelect = downSelectCount
      this.metalUp = metalUp
      this.metalDown = metalDown
      sessionStorage.setItem('upSelect', this.upSelect)
      sessionStorage.setItem('downSelect', this.downSelect)
      sessionStorage.setItem('metalUp', this.metalUp)
      sessionStorage.setItem('metalDown', this.metalDown)
      this.calAmount()
    },
    changeMainCatalog(index) {
      // 切换当前主目录
      this.currentCatalog = this.currentCatalog === index ? -1 : index;
      // 如果没有选择主目录，则清空子目录列表
      if (this.currentCatalog === -1) {
        this.subCatalogList = [];
        return;
      }
      this.getSubCatalogList(this.currentCatalog);
    },
    //选择子目录时调用
    changeSubCatalog(index) {
      this.currentSubCatalog = this.currentSubCatalog === index ? -1 : index;
      if (this.currentStep === 1) {
        this.checkCatalogNextStep();
      }
      this.removeSession();
    },
    checkCatalogNextStep() {
      if (this.currentCatalog != -1 && this.currentSubCatalog != -1) {
        this.nextStep = true;
        this.catalogId = this.catalogList[this.currentCatalog].catalogId;
        this.subCatalogId = this.catalogList[this.currentCatalog].subCataLog[this.currentSubCatalog].subCatalogId;
        this.catalogTitle = this.catalogList[this.currentCatalog].name + ' - ' + this.catalogList[this.currentCatalog].subCataLog[this.currentSubCatalog].name;
      } else {
        this.nextStep = false;
        this.catalogId = '';
        this.subCatalogId = '';
        this.catalogTitle = '';
      }

      if (this.subCatalogId != '') {

        this.cateserv = this.common.serv.get(this.subCatalogId)

        // 初始化订单数量
        if (this.subCatalogId === '1010410' ||
          this.subCatalogId === '1010510' ||
          this.subCatalogId === '1010699' ||
          this.subCatalogId === '1010700' ||
          this.subCatalogId === '3010130' ||
          this.subCatalogId === '4010110'
        ) {
          this.form.orderCount = 1;
        } else {
          this.form.orderCount = 0;
        }
        // 初始化加急费
        this.form.orderRushFee = 0.00;
        this.form.dataType = '06'
        this.form.softType = '01'
        this.common.dict.get('biz_scan_type').sort((a, b) => a.sort - b.sort)
        this.common.dict.get('biz_soft_type').sort((a, b) => a.sort - b.sort)
        this.calAmount();
        this.getTemplateList();
      }

    },
    //条件计牙位
    conditionCount(id) {
      if (id === '3010130' || id === '4010110') {
        this.form.orderCount = 1;
      } else if (id == '1010410') { //单独计算马泷桥
        if (this.isEditServOrder == '1') {
          this.form.posSingle = this.form.posSingleList ? this.form.posSingleList : '';
          this.form.posBridge = this.form.posBridgeList ? this.form.posBridgeList : '';
        }
        // const metalUp = parseInt(sessionStorage.getItem('upSelect'))||0;
        // const metalDown = parseInt(sessionStorage.getItem('metalDown'))||0;
        // let temp = metalUp > 0 ? 1 : 0 + metalDown > 0 ? 1 : 0;
        let temp = (this.metalUp > 0 ? 1 : 0) + (this.metalDown > 0 ? 1 : 0);
        if (sessionStorage.getItem('metalUp') && sessionStorage.getItem('metalDown')) {
          this.form.orderCount = temp;
        }
        let bridgeCount = 0;
        let singleCount = 0;
        if (this.singleDataList) {
          this.singleDataList.forEach(val => {
            if (typeof (val) == 'number') {
              singleCount += 1
            } else if (typeof (val) == 'string' && !val.includes('~')) {
              singleCount += 1
            }
          })
        }
        if (this.bridgeDataList) {
          this.bridgeDataList.forEach(val => {
            val.forEach(item => {
              bridgeCount += 1
            })
          })
        }

        this.quantity = singleCount + bridgeCount;
      } else {
        let num = 0
        if (this.isEditServOrder == '1') {
          this.form.posSingle = this.form.posSingleList ? this.form.posSingleList : '';
          this.form.posBridge = this.form.posBridgeList ? this.form.posBridgeList : '';
        }
        let tempMetal1 = []
        let tempMetal2 = []
        if (this.form.posSingle && this.form.posSingle.length > 0) {
          //测试遗留  1.传递为字符串提示报错  2.选择设备参数后显示的参数包含基台参数导致布局问题
          // if(typeof(this.singleDataList)=='string'){
          //   this.singleDataList = this.singleDataList.split(',');
          // }
          this.singleDataList.forEach(val => {
            val += ''
            if (!val.includes('~') && !val.includes('^') && val != '') {
              num += 1
            }
            // 基台(金属)
            if (val.includes('~')) {
              let temp = val.slice(1, 3)
              //避免不同类型重复添加
              if (!this.metal.includes(temp) && !this.metal.includes(parseInt(temp))) {
                tempMetal1.push(temp)
              }
            }
            // 基台(全瓷)
            if (val.includes('^')) {
              let temp = val.slice(1, 3)
              //避免不同类型重复添加
              if (!this.metal2.includes(temp) && !this.metal2.includes(parseInt(temp))) {
                tempMetal2.push(temp)
              }
            }
          })
        }
        // 计算选择数量
        var selectCount = num
        if (this.bridgeDataList && this.bridgeDataList.length > 0) {
          selectCount += this.calTotalLength(this.bridgeDataList);
        }

        // 适应症计算
        if (!['1010699', '1010700', '3010130', '1010410', '1010510', '4010110'].includes(this.subCatalogId)) {
          this.form.orderCount = selectCount
        }
        if (this.metal == '' && this.metal2 == '') {
          if (id == '1010210' && (tempMetal2.length > 0 || tempMetal1.length > 0)) {
            this.fund = tempMetal2.length
            this.form.orderCount = tempMetal1.length;
            this.quantity = selectCount;
          } else if (id == '1010220' && (tempMetal2.length > 0 || tempMetal1.length > 0)) {
            this.fund = tempMetal1.length
            this.form.orderCount = tempMetal2.length;
            this.quantity = selectCount;
          } else if (tempMetal1.length == 0 && tempMetal2.length == 0) {
            this.fund = 0;
            this.quantity = 0;
          } else {
            this.fund = 0;
            this.quantity = tempMetal1.length + tempMetal2.length;
          }
        } else {
          if (id == '1010210' && (this.metal2.length > 0 || this.metal.length > 0)) {
            this.fund = this.metal2.length
            this.form.orderCount = this.metal.length;
            this.quantity = selectCount;
          } else if (id == '1010220' && (this.metal2.length > 0 || this.metal.length > 0)) {
            this.fund = this.metal.length
            this.form.orderCount = this.metal2.length;
            this.quantity = selectCount;
          } else if (this.metal.length == 0 && this.metal2.length == 0) {
            this.fund = 0;
            this.quantity = 0;
          } else {
            this.fund = 0;
            this.quantity = this.metal.length + this.metal2.length;
          }
        }
      }
    },
    /**
     * 计算数组所有元素总和
     * @param {array} array 需要计算的数组
     * @returns {number} 元素总和
     */
    calTotalLength(array) {
      let total = 0;
      array.forEach(item => {
        if (Array.isArray(item)) {
          total += this.calTotalLength(item); // 递归调用
        } else {
          total += 1; // 非数组项，视为一个元素
        }
      });
      return total;
    },
    changeOrderCount(singleList, bridgeList, metal, metal2) {
      var id = this.subCatalogId;
      this.form.posSingle = singleList;
      this.form.posBridge = bridgeList;
      this.singleDataList = singleList;
      this.bridgeDataList = bridgeList;
      this.metal = metal;
      this.metal2 = metal2;
      if (this.isEditServOrder == '1') {
        this.form.posSingleList = singleList;
        this.form.posBridgeList = bridgeList;
      }
      sessionStorage.setItem('metal', JSON.stringify(this.metal));
      sessionStorage.setItem('metal2', JSON.stringify(this.metal2));

      this.conditionCount(this.subCatalogId);
      if (this.form.orderCount > 0) {
        this.colorOrderCount = '#2979ff';
        this.colorOrderAmount = '#2979ff';
      }
      this.withServCataId = this.withId(metal.length, metal2.length);
      sessionStorage.setItem("withServCataId", this.withServCataId)
      // this.addClass();
      this.calAmount();
      sessionStorage.setItem('form', JSON.stringify(this.form));
    },
    calAmount() {
      let id = this.subCatalogId;
      // 创建正畸订单，跳转回引用拦截
      if (id == '3010130') {
        sessionStorage.clear()
        return false
      }
      if (this.cateserv == null || this.cateserv.length == 0) {
        this.cateserv = this.common.serv.get(id)
      }
      // 工厂单价/诊所单价
      if (this.user.demServType == '00') {
        this.form.orderPrice = parseFloat(this.cateserv.ftyBprice).toFixed(2)
        if (this.form.desLevel == '01') {
          this.form.orderPrice = parseFloat(this.cateserv.ftyBpricePri).toFixed(2)
        } else if (this.form.desLevel == '02') {
          this.form.orderPrice = parseFloat(this.cateserv.ftyBpriceMid).toFixed(2)
        } else if (this.form.desLevel == '03') {
          this.form.orderPrice = parseFloat(this.cateserv.ftyBpriceSen).toFixed(2)
        }
      } else if (this.user.demServType == '10' || this.user.demServType == '11') {
        this.form.orderPrice = parseFloat(this.cateserv.clnBprice).toFixed(2)
        this.form.desLevel = '99'
      }
      // 获取复合适应症-基台 单价
      if (['1010210', '1010220'].includes(id) && this.fund > 0) {
        this.basePrice = this.form.orderPrice
      }
      // 获取复合适应症-上部冠 单价
      if (id === '1010120' && (this.options2 || this.options3)) {
        this.extraUnitPrice = parseFloat(Number(this.countPrice('1010210', this.form.desLevel))).toFixed(2);
      }
      if (['1010210', '1010220'].includes(id) && this.options1) {
        this.extraUnitPrice = parseFloat(Number(this.countPrice('1010120', this.form.desLevel))).toFixed(2);
      }
      if (['1010410'].includes(id) && this.options1 || this.quantity) {
        this.extraUnitPrice = parseFloat(Number(this.countPrice('1010120', this.form.desLevel))).toFixed(2);
      }
      // 上下颌不包括牙支持导板
      if (['1010699', '1010700', '3010130', '1010410', '1010510', '4010110'].includes(id)) {
        //判断上下颌是否都选择了this.upSelect
        var isUp = this.upSelect > 0 ? 1 : 0;
        var isDown = this.downSelect > 0 ? 1 : 0;
        var count = sessionStorage.getItem('metalUp') && sessionStorage.getItem('metalDown') ? isUp + isDown : this.form.orderCount;
        // 马泷桥单独计算
        if (id != '1010410') {
          //其他类型按上下颌计算显示数量
          this.form.orderCount = count;
        }
        this.form.orderAmount = parseFloat(this.form.orderCount * Number(this.form.orderPrice) +
          Number(this.quantity * this.extraUnitPrice) + Number(this.fund * this.basePrice))
          .toFixed(2);
      } else { //非上下颌类型
        this.form.orderAmount = parseFloat(this.form.orderCount * Number(this.form.orderPrice) +
          Number(this.quantity * this.extraUnitPrice) + Number(this.fund * this.basePrice)
        ).toFixed(2);
      }
      // 订单总数
      if (['1010699', '1010700', '3010130', '1010410', '1010510', '4010110'].includes(id)) {
        this.form.toothCountAll = this.form.orderCount;
      } else {
        this.form.toothCountAll = this.fund + this.quantity + this.form.orderCount;
      }
      //加急费
      if (this.form.orderRushFee != 0.00) {
        let orderAmount = Number(this.form.orderAmount) || 0;
        let orderRushFee = Number(this.form.orderRushFee) || 0;
        this.form.orderAmount = orderAmount + orderRushFee;
      }
      //编辑口扫模型费用
      if (this.form.isEditScanModel == '0') {
        this.editModelFee = 0.00
      } else {
        this.editModelFee = this.cateserv.editScanModelBprice
      }
      this.form.orderAmount = parseFloat(this.form.orderAmount) + parseFloat(this.editModelFee);
      sessionStorage.setItem('editModelFee', this.editModelFee)
      this.addIs()
    },
    // 控制按钮 - 重新选择
    clickReSelect() {
      this.fund = 0
      this.resetForm();
      this.quantity = 0
      this.upSelect = 0
      this.basePrice = 0
      this.isEditServOrder = '0'
      this.editModelFee = 0
      this.tempList2 = []
      this.downSelect = 0
      this.montageStr = ''
      this.currentStep = 1;
      this.isCreate = false
      this.nextStep = false
      this.options1 = false
      this.options2 = false
      this.options3 = false
      this.upperZero = false
      this.plateZero = false
      this.metal = []
      this.metal2 = []
      this.servCataTemp = []
      this.servBridge = false
      this.flagBridge = false
      this.form.posHole = '0'
      this.countClass = ''
      this.priceClass = ''
      this.rushClass = ''
      this.totalPriceClass = ''
      this.form.impModel = ''
      this.form.impExtra = ''
      this.form.impExtra = ''
      this.form.impSystem = ''
      this.form.plateType = ''
      this.withServCataId = ''
      this.form.scanningRod = ''
      this.form.scanningRod = ''
      this.form.subgingival = ''
      this.selectDeviceData = ''
      this.form.repairMaterial = ''
      this.isTonguesideShow = false
      this.selectDeviceDataInfo = ''
      this.form.scanningRodSupplier = ''
      this.form.isEditScanModel = '0'
      this.form.deviceType = ''
      this.form.addeviceType = ''
      this.form.toothCountAll = 0
      this.templateItem = '9999'
      this.isEditServOrder = '0'
      this.designSoftware = '00'
      this.getTemplateList() //重新加载模版参数列表
      this.removeSession();
      this.loadOrderParam();
    },
    // 按钮控制 - 下一步
    clickNextStep() {
      let id = this.subCatalogId
      // 判断复合牙位选择
      if (((['1010120'].includes(id) && (this.options2 || this.options3)) ||
        (['1010210', '1010220'].includes(id) && this.options1)) && this.quantity == 0) {
        this.openComposite();
        return false;
      }
      this.common.dict.get('biz_des_level').pop();
      if (this.withServCataId == '' || this.withServCataId == '0') {
        this.removeIs()
        this.selectDeviceDataInfo = {}
        this.addatalists = []
        this.addevicelists = []
        if (this.currentStep == 1) {
          this.metal = []
          this.metal2 = []
          this.singleDataList = []
          this.bridgeDataList = []
        }
      }
      this.setIs()
      this.prohibit = false
      sessionStorage.setItem('catalogId', this.catalogId)
      sessionStorage.setItem('catalogTitle', this.catalogTitle)
      this.form.desLevel = (this.user.demServType == '00') && this.currentStep == 1 ? '01' : this.form.desLevel
      if (this.checkValid(this.currentStep) || this.currentStep == 1) {
        if (this.currentStep == 1) {
          if (['3010130', '4010110', '4010120'].includes(id)) {
            let url = ['3010130'].includes(id) ? '/order/orthodonticsCreateOrder' : '/order/active/bracket';
            this.$router.push({
              path: url,
            })
          } else {
            this.isCreate = true
            this.form.demContact = this.user.nickName
            this.form.scanningRod = '02'
            this.isEditScanModel = '0'
            sessionStorage.setItem('cateserv', JSON.stringify(this.cateserv))
          }
        }
        sessionStorage.setItem("isCreate", JSON.stringify(this.isCreate))
        sessionStorage.setItem("subCatalogId", this.subCatalogId)
        if (this.subCatalogId == '1010120' || this.subCatalogId == '1010410') {
        }
        // 显示连桥按钮
        this.showBridgeBtn(id)
        // 显示复合适应症的选项
        this.choiceOptions(id)
        this.getTemplateList()

        //下一步中只有烤瓷冠内冠金属无需选择cam设备显示默认参数，所以仅判断其直接显示显示舌侧边补偿
        if (this.subCatalogId == '2010210') {
          this.isTonguesideShow = true
          if (this.subCatalogId != '1010698' ||
            this.subCatalogId != '1010699' ||
            this.subCatalogId != '1010700') {
            sessionStorage.setItem('isTonguesideShow', this.isTonguesideShow)
          }
        }
        if (this.currentStep == 2) {
          this.handleComposite()
          this.open();
        } else {
          this.currentStep += 1;
          sessionStorage.setItem('step', this.currentStep)
        }
      }
      this.showTemplate()
    },
    // 显示连桥按钮
    showBridgeBtn(id) {
      if (['1010698', '1010699', '1010700', '1010410'].includes(id)) {
        this.servBridge = false
      } else {
        this.servBridge = true
      }
      sessionStorage.setItem('servBridge', this.servBridge)
    },
    // 复合式适应症选择option项
    choiceOptions(id) {
      // 下一步复合适应症选中当前的
      if (id == '1010120') {
        this.options1 = true
      } else if (['1010210', '1010410'].includes(id)) {
        this.options2 = true
      } else if (id == '1010220') {
        this.options3 = true
      }
      //  else if (id == '1010410') {
      //   this.options1 = true
      //   this.options2 = true
      // }
      sessionStorage.setItem('options1', JSON.stringify(this.options1))
      sessionStorage.setItem('options2', JSON.stringify(this.options2))
      sessionStorage.setItem('options3', JSON.stringify(this.options3))
    },
    // 处理复合适应症组件选项的状态
    handleIndication(op1, op2, op3) {
      this.options1 = op1
      this.options2 = op2
      this.options3 = op3
      // 马龙桥+上部冠显示
      if (op1 && this.subCatalogId == '1010410') {
        this.servBridge = true;
        this.form.posHole = this.form.posHole == '0' ? '0' : this.form.posHole;
        this.form.repairMaterial = this.form.repairMaterial == '00' ? '00' : this.form.repairMaterial;
      } else if (this.subCatalogId == '1010410' && !op1 && this.quantity <= 0) {
        this.servBridge = false;
        this.form.repairMaterial = '';
        this.form.posHole = '0';
      }
      this.addIs();
    },
    // 处理种植体信息组件的数据
    handleImp(dataInfo) {
      for (const key in dataInfo) {
        // 复制条件：1.form[key]为空  2.dataInfo[key]不为空且dataInfo[key]不等于form[key]
        if (this.form[key] == '' || (dataInfo[key] != '' && this.form[key] != dataInfo[key])) {
          this.form[key] = dataInfo[key]
        }
      }
      if (this.form.isEditScanModel == '0') {
        this.desginCost = 0
      } else {
        this.desginCost = this.common.serv.get(this.subCatalogId).editScanModelBprice
      }
      sessionStorage.setItem('form', JSON.stringify(this.form))
      sessionStorage.setItem('desginCost', this.desginCost)
      this.calAmount()
    },
    // 下一步中处理复合选项的牙位（拼接单冠和复合牙位）
    handleComposite() {
      var tempCata2 = ''
      var tempCata3 = ''
      var id = this.subCatalogId
      this.metal.forEach((iteam, val) => {
        //最大长度无逗号
        var option = this.metal.length - 1 !== val ? ',' : ''
        //如果最大长度且2号有值或主服务也有值，那么也有逗号
        if (this.metal.length - 1 == val && (this.metal2.length > 0 || this.form.posSingle.length >
          0)) {
          if (option == '') {
            option = ','
          }
        }
        tempCata2 += this.metal.length !== val ? '~' + iteam + option : ''
      })
      this.metal2.forEach((iteam, val) => {
        var option = this.metal2.length - 1 !== val ? ',' : ''
        if (this.metal2.length - 1 == val && this.form.posSingle.length > 0) {
          if (option == '') {
            option = ','
          }
        }
        tempCata3 += this.metal2.length !== val ? '^' + iteam + option : ''
      })
      let singleList = []
      let posSingle = []
      if (this.form.posSingle && this.form.posSingle.length > 0) {
        posSingle = this.isEditServOrder == '0' ? this.form.posSingle : this.form.posSingleList
        if (!Array.isArray(posSingle)) {
          posSingle = posSingle.split(',')
        }
        posSingle.forEach(val => {
          let temp = val + ''
          if (!temp.includes('^') && !temp.includes('~') && temp != '') {
            singleList.push(val)
          }
          if (this.isEditServOrder == '1' && this.subCatalogId == '1010410') {
            if (temp.includes('~')) {
              tempCata2 += val + ','
            }
          }
        })
      }
      this.montageStr = tempCata2 + tempCata3 + singleList
      if (this.montageStr.charAt(this.montageStr.length - 1) == ',') {
        let index = this.montageStr.lastIndexOf(',')
        this.montageStr.slice(index, 1)
      }
      sessionStorage.setItem('montageStr', JSON.stringify(this.montageStr))
      if (this.metal.length > 0 || this.metal2.length > 0) {
        this.cateserv.isImpSystem = 1
        this.cateserv.isImpModel = 1
        this.cateserv.isScanningRod = 1
        this.cateserv.isScanningRodSupplier = 1
      }
      // 复合适应症的相关信息是否清掉
      if (id == '1010120' && this.metal.length == 0 && this.metal2.length == 0 && this.withServCataId == '') {
        this.form.impSystem = ''
        this.form.impModel = ''
        this.form.scanningRod = ''
        this.form.scanningRodSupplier = ''
      } else if ((id == '1010210' || id == '1010220') && this.quantity == 0) {
        this.form.repairMaterial = ''
        this.form.posHole = '0'
      }
      this.getDeviceInfo().then(() => {
        if (this.isEditServOrder == '1' && this.withServCataId != '') {
          this.$nextTick(() => {
            this.handleSelectData();
          })
        }
        if (['', '0'].includes(this.withServCataId)) {
          this.infoParam(this.catalogId == '10' ? 0 : 1, this.subCatalogId)
          this.templateParam(this.subCatalogId, this.selectDeviceData, this.form)
        }
      })
      if ((this.subCatalogId == '1010210' || this.subCatalogId == '1010220') &&
        this.withServCataId == '1010120') {
        this.common.serv.get(this.subCatalogId).isDevecieValidate = '1'
      }
    },
    //赋值selectDeviceData,非复合适应症
    infoParam(i, id) {
      if (this.designSoftware == '00') {
        this.camParamList[i].children.forEach((val, i) => {
          if (val.servCode == id && this.form.deviceType == val.deviceType) {
            this.selectDeviceData = val
          }
        })
      } else {
        // 单独赋值exo参数
        this.selectDeviceData = this.camParamList[2];
      }
    },
    //赋值selectDeviceDatainfo,复合适应症
    infoParamInfo(i, id) {
      this.camParamList[i].children.forEach((val, i) => {
        if (val.servCode == id && this.form.deviceType == val.deviceType) {
          this.selectDeviceDataInfo = val
        }
      })
    },
    // 按钮控制 - 上一步
    clickPreStep() {
      this.currentStep -= 1;
      sessionStorage.setItem('step', this.currentStep)
      // this.addClass()
    },
    editNumAdhesivegap(num) {
      this.form.adhesiveGap = Number(num);
      if (this.selectDeviceData.adhesiveGap === this.form.adhesiveGap ||
        this.selectDeviceDataInfo.adhesiveGap === this.form.adhesiveGap) {
        this.colorAdhesiveGap = '#666'
      } else {
        this.colorAdhesiveGap = '#2979ff'
      }
    },
    editNumAdhesiveextragap(num) {
      this.form.adhesiveExtraGap = Number(num);
      if (this.selectDeviceData.adhesiveExtraGap === this.form.adhesiveExtraGap ||
        this.selectDeviceDataInfo.adhesiveExtraGap === this.form.adhesiveExtraGap) {
        this.colorAdhesiveExtraGap = '#666'
      } else {
        this.colorAdhesiveExtraGap = '#2979ff'
      }
    },
    editNumMinthick(num) {
      this.form.minThick = Number(num);
      if (this.selectDeviceData.minThick === this.form.minThick ||
        this.selectDeviceDataInfo.minThick === this.form.minThick) {
        this.colorMinThick = '#666'
      } else {
        this.colorMinThick = '#2979ff'
      }
    },
    editNumWallheight(num) {
      this.form.wallHeight = Number(num);
      if (this.selectDeviceData.wallHeight === this.form.wallHeight ||
        this.selectDeviceDataInfo.wallHeight === this.form.wallHeight) {
        this.colorWallHeight = '#666'
      } else {
        this.colorWallHeight = '#2979ff'
      }
    },
    editNumEdgelinedistance(num) {
      this.form.edgeLineDistance = Number(num);
      if (this.selectDeviceData.edgeLineDistance === this.form.edgeLineDistance ||
        this.selectDeviceDataInfo.edgeLineDistance === this.form.edgeLineDistance) {
        this.colorEdgeLineDistance = '#666'
      } else {
        this.colorEdgeLineDistance = '#2979ff'
      }
    },
    editNumSmoothdistance(num) {
      this.form.smoothDistance = Number(num);
      if (this.selectDeviceData.smoothDistance === this.form.smoothDistance ||
        this.selectDeviceDataInfo.smoothDistance === this.form.smoothDistance) {
        this.colorSmoothDistance = '#666'
      } else {
        this.colorSmoothDistance = '#2979ff'
      }
    },
    editNumBurradiusr(num) {
      this.form.burRadius = Number(num);
      if (this.selectDeviceData.burRadius == this.form.burRadius ||
        this.selectDeviceDataInfo.burRadius == this.form.burRadius) {
        this.colorBurRadius = '#666'
      } else {
        this.colorBurRadius = '#2979ff'
      }
    },
    editNumBurgapoffset(num) {
      this.form.burGapOffset = Number(num);
      if (this.selectDeviceData.burGapOffset == this.form.burGapOffset ||
        this.selectDeviceDataInfo.burGapOffset == this.form.burGapOffset) {
        this.colorBurGapOffset = '#666'
      } else {
        this.colorBurGapOffset = '#2979ff'
      }
    },
    editNumEdgelineoffset(num) {
      this.form.edgeLineOffset = Number(num);
      if (this.selectDeviceData.edgeLineOffset == this.form.edgeLineOffset ||
        this.selectDeviceDataInfo.edgeLineOffset == this.form.edgeLineOffset) {
        this.colorEdgeLineOffset = '#666'
      } else {
        this.colorEdgeLineOffset = '#2979ff'
      }
    },
    editNumStretchoffset(num) {
      this.form.stretchOffset = Number(num);
      if (this.selectDeviceData.stretchOffset === this.form.stretchOffset ||
        this.selectDeviceDataInfo.stretchOffset === this.form.stretchOffset) {
        this.colorStretchOffset = '#666'
      } else {
        this.colorStretchOffset = '#2979ff'
      }
    },
    editNumAngleoffset(num) {
      this.form.angleOffset = Number(num);
      if (this.selectDeviceData.angleOffset == this.form.angleOffset ||
        this.selectDeviceDataInfo.angleOffset == this.form.angleOffset) {
        this.colorAngleOffset = '#666'
      } else {
        this.colorAngleOffset = '#2979ff'
      }
    },
    editNumOcclusalClearance(num) {
      this.form.occlusalClearance = Number(num);
      if (this.selectDeviceData.occlusalClearance == this.form.occlusalClearance ||
        this.selectDeviceDataInfo.occlusalClearance == this.form.occlusalClearance) {
        this.colorOcclusalClearance = '#666'
      } else {
        this.colorOcclusalClearance = '#2979ff'
      }
    },
    editNumAdjacencyGap(num) {
      this.form.adjacencyGap = Number(num);
      if (this.selectDeviceData.adjacencyGap == this.form.adjacencyGap ||
        this.selectDeviceDataInfo.adjacencyGap == this.form.adjacencyGap) {
        this.colorAdjacencyGap = '#666'
      } else {
        this.colorAdjacencyGap = '#2979ff'
      }
    },
    editNumTonguesideoffset(num) {
      this.form.tongueSideOffset = Number(num);
      if (this.selectDeviceData.tongueSideOffset == this.form.tongueSideOffset ||
        this.selectDeviceDataInfo.tongueSideOffset == this.form.tongueSideOffset) {
        this.colorTongueSideOffset = '#666'
      } else {
        this.colorTongueSideOffset = '#2979ff'
      }
    },
    editNumCirclesideoffset(num) {
      this.form.circleSideOffset = Number(num);
      if (this.selectDeviceData.circleSideOffset === this.form.circleSideOffset ||
        this.selectDeviceDataInfo.circleSideOffsetInfo === this.form.circleSideOffset) {
        this.colorCircleSideOffset = '#666'
      } else {
        this.colorCircleSideOffset = '#2979ff'
      }
    },
    editNumThickness(num) {
      this.form.plateThickness = Number(num);
      if (this.selectDeviceData.plateThickness === this.form.plateThickness ||
        this.selectDeviceDataInfo.plateThickness === this.form.plateThickness) {
        this.colorPlateThickness = '#666'
      } else {
        this.colorPlateThickness = '#2979ff'
      }
    },
    editNumTeethModelDeviation(num) {
      this.form.teethModelDeviation = Number(num);
      if (this.selectDeviceData.teethModelDeviation == this.form.teethModelDeviation ||
        this.selectDeviceDataInfo.teethModelDeviation == this.form.teethModelDeviation
      ) {
        this.colorTeethModelDeviation = '#666'
      } else {
        this.colorTeethModelDeviation = '#2979ff'
      }
    },
    editNumRecessedRetentionAmount(num) {
      this.form.recessedRetentionAmount = Number(num);
      if (this.selectDeviceData.recessedRetentionAmount == this.form.recessedRetentionAmount ||
        this.selectDeviceDataInfo.recessedRetentionAmount == this.form.recessedRetentionAmount
      ) {
        this.colorRecessedRetentionAmount = '#666'
      } else {
        this.colorRecessedRetentionAmount = '#2979ff'
      }
    },
    editNumGuideRingCompensatio(num) {
      this.form.guideRingCompensatio = Number(num);
      if (this.selectDeviceData.guideRingCompensatio == this.form.guideRingCompensatio ||
        this.selectDeviceDataInfo.guideRingCompensatio == this.form.guideRingCompensatio
      ) {
        this.colorGuideRingCompensatio = '#666'
      } else {
        this.colorGuideRingCompensatio = '#2979ff'
      }
    },
    editNumPolymerization(num) {
      this.form.polymerization = Number(num);
      if (this.selectDeviceData.polymerization == this.form.polymerization ||
        this.selectDeviceDataInfo.polymerization == this.form.polymerization
      ) {
        this.colorPolymerization = '#666'
      } else {
        this.colorPolymerization = '#2979ff'
      }
    },
    editNumBaseHeight(num) {
      this.form.baseHeight = Number(num);
      if (this.selectDeviceData.baseHeight == this.form.baseHeight ||
        this.selectDeviceDataInfo.baseHeight == this.form.baseHeight
      ) {
        this.colorBaseHeight = '#666'
      } else {
        this.colorBaseHeight = '#2979ff'
      }
    },
    editNumShoulderWidth(num) {
      this.form.shoulderWidth = Number(num);
      if (this.selectDeviceData.shoulderWidth == this.form.shoulderWidth ||
        this.selectDeviceDataInfo.shoulderWidth == this.form.shoulderWidth
      ) {
        this.colorShoulderWidth = '#666'
      } else {
        this.colorShoulderWidth = '#2979ff'
      }
    },
    editNumShoulderAngle(num) {
      this.form.shoulderAngle = Number(num);
      if (this.selectDeviceData.shoulderAngle == this.form.shoulderAngle ||
        this.selectDeviceDataInfo.shoulderAngle == this.form.shoulderAngle
      ) {
        this.colorShoulderAngle = '#666'
      } else {
        this.colorShoulderAngle = '#2979ff'
      }
    },
    editNumSupragingival(num) {
      this.form.supragingival = Number(num);
      if (this.selectDeviceData.supragingival == this.form.supragingival ||
        this.selectDeviceDataInfo.supragingival == this.form.supragingival
      ) {
        this.colorSupragingival = '#666'
      } else {
        this.colorSupragingival = '#2979ff'
      }
    },
    // 统一调用然后传递对应字段
    editNum(field, num) {
      let chatFirst = field.charAt(0);
      //分别设置字段别名和字段颜色别名
      let fieldName = chatFirst.toLowerCase() + field.slice(1);
      let fieldColorName = chatFirst.toUpperCase() + field.slice(1);

      this.form[fieldName] = Number(num);
      if (this.selectDeviceDataInfo[fieldName] == this.form[fieldName]) {
        this[`color${fieldColorName}`] = '#666';
      } else {
        this[`color${fieldColorName}`] = '#2979ff';
      }
    },
    // 切换是否开孔，复制默认开孔直径2.5
    changePosHole() {
      this.form.holeDiameter = 2.5
    },
    changeDeviceType() {
      if (this.designSoftware == '10') {
        // 选择设计软件为exo后，seldata获取模版的参数，然后在这里给表单数据初始化
        this.initDeviceParam(this.form, this.selectDeviceData);
        return false
      }
      if (this.selectDeviceData.deviceType != this.form.deviceType && this.designSoftware == '00') {
        this.templateItem = '9999'
      }
      this.selectDeviceData = {}
      for (let i = 0; i < this.datalists.length; i++) {
        if (this.datalists[i].deviceType == this.form.deviceType) {
          this.selectDeviceData = this.datalists[i]
          if (this.subCatalogId != '1010700') {
            sessionStorage.setItem("selectDeviceData", JSON.stringify(this.selectDeviceData))
          }
          //是否显示舌侧边补偿
          if (this.subCatalogId == '2010220' || this.subCatalogId == '2010210') {
            this.isTonguesideShow = true
            if (this.subCatalogId != '1010698' ||
              this.subCatalogId != '1010699' ||
              this.subCatalogId != '1010700') {
              sessionStorage.setItem('isTonguesideShow', this.isTonguesideShow)
            }
          }
        }
      }
      if (this.form.deviceType == '99') {
        this.getDeviceInfo()
      }
      if (this.templateItem != '9999') {
        this.templateOptions.forEach(val => {
          if (this.templateItem == val.id) {
            this.selectDeviceData = val
          }
        })
      }
      this.initDeviceParam(this.form, this.selectDeviceData)
      if ((this.subCatalogId == '1010210' || this.subCatalogId == '1010220') && this.withServCataId == '1010120') {
        this.form.deviceType = this.form.addeviceType
      }
      this.renovate = !this.renovate
    },
    changeAddeviceType() {
      for (let i = 0; i < this.addatalists.length; i++) {
        if (this.addatalists[i].deviceType == this.form.addeviceType) {
          this.selectDeviceDataInfo = this.addatalists[i]
          if (this.subCatalogId != '1010700') {
            sessionStorage.setItem("selectDeviceDataInfo", JSON.stringify(this.selectDeviceDataInfo))
          }
          //是否显示舌侧边补偿
          if (this.subCatalogId == '2010220' || this.subCatalogId == '2010210') {
            this.isTonguesideShow = true
            if (this.subCatalogId != '1010698' ||
              this.subCatalogId != '1010699' ||
              this.subCatalogId != '1010700') {
              sessionStorage.setItem('isTonguesideShow', this.isTonguesideShow)
            }
          }
        }
      }
      if (this.form.addeviceType == '99') {
        this.getDeviceInfo()
      }
      this.initDeviceParamInfo(this.selectDeviceDataInfo)
      if (['1010210', '1010220', '1010410'].includes(this.subCatalogId) && this.withServCataId == '1010120') {
        this.form.deviceType = this.form.addeviceType
      }
      this.paramKey += 1
    },
    // 合并两个对象
    mergeNonZeroObjects(obj1, obj2) {
      const merged = {};
      // 遍历第一个对象的每个属性
      for (const key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          if (obj1[key] !== 0 || (obj2.hasOwnProperty(key) && obj2[key] === 0)) {
            merged[key] = obj1[key];
          }
        }
      }
      // 遍历第二个对象的每个属性，并且只合并非零属性，同时保留两个对象都为零的属性
      for (const key in obj2) {
        if (obj2.hasOwnProperty(key)) {
          if (obj2[key] !== 0 || (obj1.hasOwnProperty(key) && obj1[key] === 0)) {
            merged[key] = obj2[key];
          }
        }
      }
      if (merged.orderRushFee == undefined) {
        merged.orderRushFee = 0
      }
      this.form = merged
      return merged;
    },
    //获取设备列表和对应设备参数api
    async getDeviceInfo() {
      this.$api.get({
        url: '/common/deviceParam',
        isToken: false
      }).then(res => {
        // console.log("设备参数字典！！！！：",res)
        this.camParamList = res.data
        this.datalists = [];
        this.devicelists = [];
        this.addatalists = [];
        this.addevicelists = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].servCode == this.catalogId) {
            for (let j = 0; j < res.data[i].children.length; j++) {
              if (res.data[i].children[j].servCode == this.withServCataId) {
                if (this.withServCataId == '1010220' || this.withServCataId == '1010210') {
                  this.addatalists.push(res.data[i].children[j])
                  this.selectDeviceDataInfo = this.addatalists[0]
                } else {
                  this.addatalists.push(res.data[i].children[j])
                  var temp = {
                    label: '',
                    value: ''
                  };
                  temp.label = res.data[i].children[j].deviceName;
                  temp.value = res.data[i].children[j].deviceType;
                  this.addevicelists.push(temp)
                }
              }
              if (res.data[i].children[j].servCode == this.subCatalogId) {
                //烤瓷冠内冠金属
                if (this.subCatalogId == '2010210') {
                  this.selectDeviceData = res.data[i].children[14]
                  if (this.isEditServOrder == '0') {
                    this.initDeviceParam(this.form, this.selectDeviceData)
                  } else {
                    this.initDeviceParam(this.selectDeviceData, this.form)
                  }
                  this.renovate = !this.renovate
                } else if (this.subCatalogId == '1010220' || this.subCatalogId == '1010210' || this
                  .subCatalogId == '1010310' || this.subCatalogId == '1010320') {
                  this.datalists.push(res.data[i].children[j])
                  this.selectDeviceData = this.datalists[0]
                  if (this.isEditServOrder == '0') {
                    this.initDeviceParam(this.form, this.selectDeviceData)
                  } else {
                    this.selectDeviceData.polymerization = this.form.polymerization;
                    this.selectDeviceData.baseHeight = this.form.baseHeight;
                    this.selectDeviceData.shoulderWidth = this.form.shoulderWidth;
                    this.selectDeviceData.shoulderAngle = this.form.shoulderAngle;
                    this.selectDeviceData.supragingival = this.form.supragingival;
                  }
                  this.renovate = !this.renovate
                } else {
                  this.datalists.push(res.data[i].children[j])
                  var temp = {
                    label: '',
                    value: ''
                  };
                  temp.label = res.data[i].children[j].deviceName;
                  temp.value = res.data[i].children[j].deviceType;
                  this.devicelists.push(temp)
                }
              }
            }
          }
        }
        var temp = {
          label: '其他',
          value: '99'
        };
        this.devicelists.push(temp)
        this.addevicelists.push(temp)
        if (this.subCatalogId == '1010700') {
          this.selectDeviceData = ''
        }
        if (this.isEditServOrder == '0') {
          this.removeDefalutParam()
        }
        sessionStorage.setItem("datalists", JSON.stringify(this.datalists))
        sessionStorage.setItem("devicelists", JSON.stringify(this.devicelists))
        sessionStorage.setItem("addatalists", JSON.stringify(this.addatalists))
        sessionStorage.setItem("addevicelists", JSON.stringify(this.addevicelists))
        sessionStorage.setItem("selectDeviceData", this.selectDeviceData == '' ? '' : JSON.stringify(this.selectDeviceData))
        sessionStorage.setItem("selectDeviceDataInfo", this.selectDeviceDataInfo == '' ? '' : JSON.stringify(this.selectDeviceDataInfo))
        sessionStorage.setItem("camParamList", JSON.stringify(this.camParamList))
        if (this.form.deviceType == '99') {
          this.switchif(this.form.deviceType, this.selectDeviceData, res)
          this.zeroDeviceParam(res, this.selectDeviceData);
        }
        if (this.form.addeviceType == '99') {
          this.switchif(this.form.addeviceType, this.selectDeviceDataInfo, res)
          this.zeroDeviceParam(res, this.selectDeviceDataInfo);
        }
      })
      if (this.isEditServOrder == '1') {
        this.assignment();
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
    },
    // switch对用的设备参数
    switchif(type, arr, res) {
      if (type == '99') {
        switch (this.subCatalogId) {
          case '1010120':
            arr = res.data[0].children[3]
            break;
          case '1010698':
            arr = res.data[0].children[16]
            arr.adjacencyGap = null
            arr.occlusalClearance = null
            break;
          case '1010699':
            arr = res.data[0].children[16]
            arr.adjacencyGap = null
            arr.occlusalClearance = null
            break;
          case '2010120':
            arr = res.data[1].children[0]
            break;
          case '2010220':
            arr = res.data[1].children[0]
            this.isTonguesideShow = true
            break;
          case '2010320':
            arr = res.data[1].children[28]
            break;
          case '2010420':
            arr = res.data[1].children[32]
            break;
        }
      }
      if (this.form.deviceType == '99' && this.subCatalogId != '1010210' && this.subCatalogId != '1010220') {
        this.selectDeviceData = arr
      }
      if (this.form.addeviceType == '99' && (this.subCatalogId == '1010210' || this.subCatalogId == '1010220')) {
        this.selectDeviceDataInfo = res.data[0].children[3]
      }
    },
    // 重置订单下单方信息
    loadOrderParam() {
      this.form.demName = this.user.nickName;
      this.form.demContact = this.user.nickName;
      this.form.demPhone = this.user.mobile;
    },
    //初始化设备参数
    initDeviceParam(list, deviceData) {
      list.adhesiveGap = deviceData.adhesiveGap
      list.adhesiveExtraGap = deviceData.adhesiveExtraGap
      list.minThick = this.subCatalogId == '2010210' ? 0.4 : (this.subCatalogId == '2010220' ? 0.6 : deviceData.minThick)
      list.wallHeight = deviceData.wallHeight
      list.edgeLineDistance = deviceData.edgeLineDistance
      list.smoothDistance = deviceData.smoothDistance
      list.burRadius = deviceData.burRadius
      list.burGapOffset = deviceData.burGapOffset
      list.edgeLineOffset = deviceData.edgeLineOffset
      list.stretchOffset = deviceData.stretchOffset
      list.angleOffset = deviceData.angleOffset
      list.tongueSideOffset = deviceData.tongueSideOffset
      list.circleSideOffset = deviceData.circleSideOffset

      list.polymerization = deviceData.polymerization
      list.baseHeight = deviceData.baseHeight
      list.shoulderWidth = deviceData.shoulderWidth
      list.shoulderAngle = deviceData.shoulderAngle
      list.supragingival = deviceData.supragingival
      list.shoulderPosition = deviceData.shoulderPosition
      list.plateThickness = deviceData.plateThickness
      list.teethModelDeviation = deviceData.teethModelDeviation
      list.recessedRetentionAmount = deviceData.recessedRetentionAmount
      list.guideRingCompensatio = deviceData.guideRingCompensatio
      list.adjacencyGap = deviceData.adjacencyGap
      list.occlusalClearance = deviceData.occlusalClearance
      // exo
      list.innerCrownThickness = deviceData.innerCrownThickness
      list.occlusionSpace = deviceData.occlusionSpace
      list.adhesiveThickness = deviceData.adhesiveThickness
      list.edgeHorizontalWidth = deviceData.edgeHorizontalWidth
      list.edgeTiltWidth = deviceData.edgeTiltWidth
      list.edgeInclinationAngle = deviceData.edgeInclinationAngle
      list.edgeVerticalHeight = deviceData.edgeVerticalHeight
      list.topAdhesiveWidth = deviceData.topAdhesiveWidth
      list.axialExtraClearance = deviceData.axialExtraClearance
      list.radialExtraClearance = deviceData.radialExtraClearance
      list.crossSectionalAreaConnector = deviceData.crossSectionalAreaConnector
      list.prohibitedFillingMargin = deviceData.prohibitedFillingMargin
      list.gingivalThickness = deviceData.gingivalThickness
      list.distanceAdjacentTooth = deviceData.distanceAdjacentTooth
      list.marginLineShift = deviceData.marginLineShift
      list.cementGap = deviceData.cementGap
      list.fromMarginLine = deviceData.fromMarginLine
      list.marginCementWidth = deviceData.marginCementWidth

      if (this.selectDeviceDataInfo && this.withServCataId) {
        this.mergeNonZeroObjects(this.selectDeviceDataInfo, this.form)
      }
    },
    //初始化设备参数(额外，上部冠/基台)
    initDeviceParamInfo(deviceData) {
      this.form.adhesiveGap = deviceData.adhesiveGap
      this.form.adhesiveExtraGap = deviceData.adhesiveExtraGap
      this.form.minThick = deviceData.minThick
      this.form.wallHeight = deviceData.wallHeight
      this.form.edgeLineDistance = deviceData.edgeLineDistance
      this.form.smoothDistance = deviceData.smoothDistance
      this.form.burRadius = deviceData.burRadius
      this.form.burGapOffset = deviceData.burGapOffset
      this.form.edgeLineOffset = deviceData.edgeLineOffset
      this.form.stretchOffset = deviceData.stretchOffset
      this.form.angleOffset = deviceData.angleOffset
      this.form.tongueSideOffset = deviceData.tongueSideOffset
      this.form.circleSideOffset = deviceData.circleSideOffset
      this.form.adjacencyGap = deviceData.adjacencyGap
      this.form.occlusalClearance = deviceData.occlusalClearance
    },
    //其他设备类型，设备参数初始0
    zeroDeviceParam(data, arr) {
      let id = this.subCatalogId
      if (id == '1010698' || id == '1010699') {
        this.plateZero = true
        this.match(data.data, '黑格', arr)
      } else if (id == '2010320' || id == '2010420') {
        this.upperZero = true
        this.match(data.data, '柯乐德', arr)
      } else {
        this.upperZero = true
        this.match(data.data, '威兰德', arr)
      }
      sessionStorage.setItem("selectDeviceData", JSON.stringify(this.selectDeviceData))
      sessionStorage.setItem("upperZero", JSON.stringify(this.upperZero))
      sessionStorage.setItem("plateZero", JSON.stringify(this.plateZero))
      this.initDeviceParam(this.form, this.selectDeviceData)
    },
    match(data, deviceName, arr) {
      data.forEach((val, index) => {
        val.children.forEach(item => {
          if (item.servCode == this.subCatalogId && item.deviceName == deviceName) {
            for (var key1 in arr) {
              if (key1 != 'deviceName' && key1 != 'deviceType') {
                arr[key1] = item[key1]
              }
            }
          }
        })
      })
    },
    message(m) {
      this.$message.error({
        message: m
      })
    },
    // 设备参数选择其他后selectDeviceData参数会被设置为0，调用下面这个方法在提交表到前设置selectDeviceData的参数
    assignment() {
      for (var key1 in this.selectDeviceData) {
        for (var key2 in this.form) {
          if (key1 == key2) {
            this.selectDeviceData[key1] = this.form[key1]
          }
        }
      }
    },
    // 备注历史记录缓存
    remarkCache() {
      if (!this.remarkHistory.includes(this.form.orderRemark) && this.form.orderRemark != '') {
        this.remarkHistory.push(this.form.orderRemark)
      }
      if (this.remarkHistory.length > 10) {
        this.remarkHistory.splice(10, 1)
      }
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    // 去掉form默认cam参数
    removeDefalutParam() {
      // 需要限制不赋值的字段较多，而模版赋值的字段
      let temp = ['adhesiveGap', 'adhesiveExtraGap', 'minThick', 'wallHeight', 'edgeLineDistance', 'smoothDistance', 'burRadius', 'burGapOffset', 'edgeLineOffset', , 'stretchOffset', , 'angleOffset', , 'tongueSideOffset', , 'circleSideOffset', , 'polymerization', , 'baseHeight', , 'shoulderWidth', , 'shoulderAngle', , 'supragingival', , 'shoulderPosition', 'plateThickness', 'teethModelDeviation', 'recessedRetentionAmount', 'guideRingCompensatio', 'adjacencyGa,', 'occlusalClearance']
      for (var key1 in this.selectDeviceData) {
        for (var key2 in this.form) {
          if (key1 == key2 && key1 != 'deviceType' && this.selectDeviceData[key1] != '' && temp.includes(key1)) {
            this.form[key1] = this.selectDeviceData[key1]
          }
        }
      }
    },
    // 提交表单
    submitForm() {
      let id = this.subCatalogId;
      if ((this.form.deviceType == '99' || this.form.addeviceType == '99') && this.form.otherDeviceType == '') {
        this.$yxz.msg('请填写其他CAM制造设备名称', 'error')
        return false;
      }
      if (this.form.softType == '99' && this.form.otherSoftType == '') {
        this.$yxz.msg('请填写其他口扫品牌', 'error')
        return false;
      }
      if (this.form.dataType == '99' && this.form.otherDataType == '') {
        this.$yxz.msg('请填写其他数据类型', 'error')
        return false;
      }
      if (this.dataScanRod.length == 0 && (id == '1010210' || id == '1010220' || id == '1010310' || id == '1010320' ||
        id == '1010410' || id == '1010510')) {
        this.$yxz.msg('请上传扫描杆和替代体数据库文件', 'error')
        return false;
      }

      if (this.checkValid(this.currentStep)) {
        if (this.isEditServOrder == '1') {
          this.handleComposite()
        }
        let orderNo = ''
        if (sessionStorage.getItem('updateForm')) {
          orderNo = JSON.parse(sessionStorage.getItem('updateForm'))
        }
        this.assignment()
        this.prohibit = true
        /**
         * montageStr -> form.posSingle覆盖条件
         * 1.修改订单下，montageStr为空，posSingle就等于原数据
         * --------------------------------------------------
         * 条件一：下单时montageStr赋值posSingle 基台 上部冠 马泷桥
         * 条件二：修改时，单冠牙位不等于原订单缓存牙位时赋值（判断条件为转JSON是否相等）
         *
         */
        let detail = JSON.parse(sessionStorage.getItem('updateForm'));
        let idFlag = ['1010210', '1010220', '1010120', '1010410'].includes(id);
        let create = this.isEditServOrder == '0'
        if (idFlag) {
          if (create) {
            this.form.posSingle = this.montageStr;
          } else {
            let arrSingle = JSON.stringify(this.form.posSingle);
            let arrSingleList = JSON.stringify(detail.posSingleList);
            if (arrSingle != arrSingleList) {
              this.form.posSingle = this.montageStr;
            }
          }
        }

        let formData = new FormData();
        for (var key in this.form) {
          formData.append(key, this.form[key]);
        }
        this.formData = formData;
        this.addForm();
        this.remarkCache();
      }
    },
    // 修改订单打开留言dialog后的继续制作按钮
    submitUpdate() {
      // 防止连点进入
      if (this.isSubmitting) {
        return
      }

      let id = this.subCatalogId;
      if (this.isEditServOrder == '1' && this.currentStep == '2') {
        if (((['1010120'].includes(id) && (this.options2 || this.options3)) ||
          (['1010210', '1010220'].includes(id) && this.options1)) && this.quantity == 0) {
          this.openComposite();
          return false;
        }
      }
      if (this.withServCataId == '0') {
        this.withServCataId = ''
      }
      if (this.isEditServOrder == '1' && this.currentStep == '2') {
        let updateWid = JSON.parse(sessionStorage.getItem('updateForm')).withServCataId;
        // 转数组判断withServCataId
        updateWid = typeof (updateWid) == 'string' ? updateWid.split(',') : updateWid;
        let flag = this.withServCataId == '1010120' && this.metal.length > 0 && this.metal2.length > 0;
        if (!updateWid.includes(this.withServCataId) || flag) {
          this.$message({
            type: 'error',
            message: '服务单类型改变，请点击下一步确认cam设备参数后继续修改订单'
          })
          return false;
        }
        this.selectDeviceData = {}
        this.templateParam(this.subCatalogId, this.selectDeviceData, this.form);
      }
      // 根据订单的状态，显示对应的内容提示
      if (this.isEditServOrder == '1' && JSON.parse(sessionStorage.getItem('updateForm')).orderStatus == '60') {
        this.msgDialog = true
      } else {
        this.msgDialog = false
        this.submitForm()
      }
    },
    async uploadFile({
                       response,
                       file,
                       data
                     }) {
      var loading = this.$loading({
        text: '等待上传完成，已上传 0%'
      });
      uploadByPieces({
        file: file, // 文件
        data: data,
        pieceSize: 3, // 分片大小
        concurrent: 3,
        process: res => {
          loading.setText('等待上传完成，已上传' + res + '%')
          // console.log('分片上传 -> process', res)
          // if (res == 100) {
          // loading.close();
          // }
        },
        success: res => {
          var url = 'https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/user/order/20209705/20251118_2010120_test/scan/cfcd208495d565ef66e7dff9f98764da.stl';
          var temp = {
            url: res.data.url && res.data.url != '' ? res.data.url : url,
            name: file.name
          }
          if (data.objectType == '07') { //口扫数据
            this.dataScan.push(temp)
          } else if (data.objectType == '08') { //设计单照片
            this.dataSheet.push(temp)
          } else if (data.objectType == '09') { //口内照片
            this.dataMouth.push(temp)
          } else if (data.objectType == '10') { //CBCT数据
            this.dataCbct.push(temp)
            this.fileNum += 1
          } else if (data.objectType == '21') { //扫描杆数据库
            this.dataScanRod.push(temp)
          }
          this.successFileCount += 1
          if (this.successFileCount == this.selectFileCount) {
            loading.close();
            this.selectFileCount = 0;
            this.successFileCount = 0;
          }
          console.log('分片上传 -> success', res)
          this.sessionFile(this.dataScan, 'dataScan')
          this.sessionFile(this.dataSheet, 'dataSheet')
          this.sessionFile(this.dataMouth, 'dataMouth')
          this.sessionFile(this.dataCbct, 'dataCbct')
          this.sessionFile(this.dataScanRod, 'dataScanRod')
        },
        error: e => {
          this.selectFileCount = 0
          this.successFileCount = 0
          this.$yxz.msg('网络错误'.e, 'success')
          // console.log('分片上传 -> error', e)
        }
      })
    },
    // 如果上传文件 is not null 则存session
    sessionFile(val, name) {
      if (val != '') {
        sessionStorage.setItem(name, JSON.stringify(val))
      }
    },
    handleChange(file) {
      this.selectFileCount += 1
      return true;
    },
    clickTip() {
      this.$yxz.msg("请完成示例查看后上传文件。", 'warning', 4000, {
        customClass: 'adv-message'
      })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList, type) {
      let name = ''
      let tempdata = ''
      if (type == '07') {
        name = 'dataScan';
        tempdata = this.dataScan;
      } else if (type == '08') {
        name = 'dataSheet';
        tempdata = this.dataSheet;
      } else if (type == '09') {
        name = 'dataMouth';
        tempdata = this.dataMouth;
      } else if (type == '10') {
        name = 'dataCbct';
        tempdata = this.dataCbct;
      } else if (type == '21') {
        name = 'dataScanRod';
        tempdata = this.dataScanRod;
      }
      if (tempdata == '') {
        this.$message("数据错误！！")
        return false
      }
      for (let i = 0; i < tempdata.length; i++) {
        if (file.name === tempdata[i].name) {
          tempdata.splice(i, 1);
        }
      }
      this.$message({
        type: 'success',
        message: '移除成功!'
      });
      this.fileNum -= 1
      this.sessionFile(tempdata, name);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed() {
      this.$message({
        type: 'error',
        message: '最多支持5个文件上传，上传数量大于5请打包上传'
      })
    },
    // 上传前处理
    beforeUpload(file) {
      let fileSize = file.size
      const FIVE_M = 10 * 1024 * 1024;
      //大于5M，不允许上传
      if (fileSize > FIVE_M) {
        this.$message.error("最大上传10M")
        return false
      }
      //判断文件类型
      let fileName = file.name
      let reg = /^.+\.(jpeg|png|jpg)$/
      if (!reg.test(fileName)) {
        this.$message.error("只能上传jpeg|png|jpg!")
        return false
      }
      this.selectFileCount += 1
      return true
    },
    // 只保留上传文件url、name字段
    removeField(file) {
      return file.map(val => ({
        url: val.url,
        name: val.name
      }));
    },
    //添加
    addForm() {
      //节流
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true

      var tempDataScan = [];
      var tempDataSheet = [];
      var tempDataMouth = [];
      var tempDataCbct = [];
      var tempDataScanRod = [];
      tempDataScan = JSON.stringify(this.removeField(this.dataScan))
      tempDataSheet = JSON.stringify(this.removeField(this.dataSheet))
      tempDataMouth = JSON.stringify(this.removeField(this.dataMouth))
      tempDataCbct = JSON.stringify(this.removeField(this.dataCbct))
      tempDataScanRod = JSON.stringify(this.removeField(this.dataScanRod))
      this.initDeviceParam(this.form, this.selectDeviceData)
      // 基台复合适应症传值cam名称
      if ((this.subCatalogId == '1010210' || this.subCatalogId == '1010220') && this.withServCataId == '1010120') {
        this.form.deviceType = this.form.addeviceType
      }
      var bridgeData = ''
      if (this.isEditServOrder == '1') {
        this.form.posBridge = this.bridgeDataList
      }
      if (this.form.posBridge && this.form.posBridge.length > 0) {
        if (Array.isArray(this.form.posBridge) === false) { //修改服务单连桥参数是直接读取数据库，直接赋值即可
          bridgeData = this.form.posBridge
        } else {
          bridgeData = this.form.posBridge.map(subArray => subArray.join(',')).join('/')
        }
      }
      // 基台订单修改，牙位判断是否切换类型
      let tempId = this.subCatalogId;
      let wid = this.withServCataId;
      let flag1 = tempId == '1010210' && ['1010120', '1010220', '',].includes(wid);
      let flag2 = tempId == '1010220' && ['1010120', '1010210', '',].includes(wid);
      if (!this.isCreate && (flag1 || flag2)) {
        let strList = this.form.posSingle.toString();
        if (strList.includes('^') && !strList.includes('~')) {
          this.subCatalogId = '1010220';
        } else if (!strList.includes('^') && strList.includes('~')) {
          this.subCatalogId = '1010210';
        }
      }
      var orderData = {
        servCataId: this.subCatalogId,
        demName: this.formData.get('demName'),
        demContact: this.formData.get('demContact'),
        demPhone: this.formData.get('demPhone'),
        demSex: this.formData.get('demSex'),
        demPatient: this.formData.get('demPatient'),
        desLevel: this.formData.get('desLevel'),
        // orderCount: this.formData.get('orderCount'),
        orderCount: this.formData.get('toothCountAll'),
        orderPrice: this.formData.get('orderPrice'),
        orderRushFee: this.formData.get('orderRushFee'),
        orderAmount: this.formData.get('orderAmount'),
        orderRemark: this.formData.get('orderRemark'),
        softType: this.formData.get('softType'),
        otherSoftType: this.formData.get('otherSoftType'),
        dataType: this.formData.get('dataType'),
        otherDataType: this.formData.get('otherDataType'),
        posSingle: this.formData.get('posSingle'),
        posBridge: bridgeData,
        posHole: this.formData.get('posHole'),
        plateType: this.formData.get('plateType'),

        impSystem: this.formData.get('impSystem'),
        impModel: this.formData.get('impModel'),
        impExtra: this.formData.get('impExtra'), // impSystem = 99时
        /** 开孔直径 */
        holeDiameter: this.subCatalogId == '1010120' || this.withServCataId.includes('1010120') ? this.formData.get('holeDiameter') : null,
        scanningRod: this.formData.get('scanningRod'),
        /** 扫描杆 */
        scanningRodSupplier: this.formData.get('scanningRodSupplier'),
        /** 扫描杆供应商 */
        subgingival: this.formData.get('subgingival'),
        /** 精密附件及型号 */
        surgicalBoxSupplier: this.formData.get('surgicalBoxSupplier'),
        plantModel: this.formData.get('plantModel'),
        repairMaterial: this.formData.get('repairMaterial'), //修复体材质

        deviceType: this.formData.get('deviceType'),
        otherDeviceType: this.formData.get('otherDeviceType'),
        briCraft: this.formData.get('briCraft'),
        collar: this.formData.get('collar'),
        gingiva: this.formData.get('gingiva') == 'undefined' ? null : this.formData.get('gingiva'), //牙龈位置
        shoulderPosition: this.formData.get('shoulderPosition') == 'undefined' ? null : this.formData.get('shoulderPosition'), //肩台与牙龈位置的（唇侧舌侧近远中）

        adhesiveGap: this.selectDeviceData.adhesiveGap || this.selectDeviceDataInfo.adhesiveGap ? this.formData.get('adhesiveGap') : null, //黏着剂间隙
        adhesiveExtraGap: this.selectDeviceData.adhesiveExtraGap || this.selectDeviceDataInfo.adhesiveExtraGap ? this.formData.get('adhesiveExtraGap') : null, //额外黏着剂间隙：0.04mm
        minThick: this.selectDeviceData.minThick || this.selectDeviceDataInfo.minThick ? this.formData.get('minThick') : null, //最小厚度：0.6mm
        wallHeight: this.selectDeviceData.wallHeight || this.selectDeviceDataInfo.wallHeight ? this.formData.get('wallHeight') : null, //壁高度：0.8mm
        edgeLineDistance: this.selectDeviceData.edgeLineDistance || this.selectDeviceDataInfo.edgeLineDistance ? this.formData.get('edgeLineDistance') : null, //到边缘线的距离：1mm
        smoothDistance: this.selectDeviceData.smoothDistance || this.selectDeviceDataInfo.smoothDistance ? this.formData.get('smoothDistance') : null, //平滑距离: 0.2mm
        burRadius: this.selectDeviceData.burRadius || this.selectDeviceDataInfo.burRadius ? this.formData.get('burRadius') : null, //车针半径 : 0.5mm
        burGapOffset: this.selectDeviceData.burGapOffset || this.selectDeviceDataInfo.burGapOffset ? this.formData.get('burGapOffset') : null, //车针补偿间距: 0.52mm
        edgeLineOffset: this.selectDeviceData.edgeLineOffset || this.selectDeviceDataInfo.edgeLineOffset ? this.formData.get('edgeLineOffset') : null, //边缘线补偿: 0.15mm
        stretchOffset: this.selectDeviceData.stretchOffset || this.selectDeviceDataInfo.stretchOffset ? this.formData.get('stretchOffset') : null, //延伸补偿:0.1mm
        angleOffset: this.selectDeviceData.angleOffset || this.selectDeviceDataInfo.angleOffset ? this.formData.get('angleOffset') : null, //补偿角度:25-60度
        isTongueSide: this.formData.get('isTongueSide'), //舌侧边补偿（宽度）0=无,1=有
        sideOffset: this.formData.get('sideOffset'), //舌侧边参数 0=舌侧边,1=360度边
        tongueSideOffset: this.selectDeviceData.tongueSideOffset || this.selectDeviceDataInfo.tongueSideOffset ? this.formData.get('tongueSideOffset') : null, //舌侧边 1mm
        circleSideOffset: this.selectDeviceData.circleSideOffset || this.selectDeviceDataInfo.circleSideOffset ? this.formData.get('circleSideOffset') : null, //360度边1mm

        polymerization: this.selectDeviceData.polymerization || this.selectDeviceDataInfo.polymerization ? this.formData.get('polymerization') : null, //聚合度6度
        baseHeight: this.selectDeviceData.baseHeight || this.selectDeviceDataInfo.baseHeight ? this.formData.get('baseHeight') : null, //基台高度 4.5mm
        shoulderWidth: this.selectDeviceData.shoulderWidth || this.selectDeviceDataInfo.shoulderWidth ? this.formData.get('shoulderWidth') : null, //肩台宽度 1mm
        shoulderAngle: this.selectDeviceData.shoulderAngle || this.selectDeviceDataInfo.shoulderAngle ? this.formData.get('shoulderAngle') : null, //肩台角度 120度
        supragingival: this.selectDeviceData.supragingival || this.selectDeviceDataInfo.supragingival ? this.formData.get('supragingival') : null, //龈下参数
        plateThickness: this.selectDeviceData.plateThickness || this.selectDeviceDataInfo.plateThickness ? this.formData.get('plateThickness') : null, //导板厚度
        teethModelDeviation: this.selectDeviceData.teethModelDeviation || this.selectDeviceDataInfo.teethModelDeviation ? this.formData.get('teethModelDeviation') : null, //牙齿/模型偏移
        recessedRetentionAmount: this.selectDeviceData.recessedRetentionAmount || this.selectDeviceDataInfo.recessedRetentionAmount ? this.formData.get('recessedRetentionAmount') : null, //倒凹量
        guideRingCompensatio: this.selectDeviceData.guideRingCompensatio || this.selectDeviceDataInfo.guideRingCompensatio ? this.formData.get('guideRingCompensatio') : null, //导环的补偿
        adjacencyGap: this.selectDeviceData.adjacencyGap || this.selectDeviceDataInfo.adjacencyGap ? this.formData.get('adjacencyGap') : null,
        occlusalClearance: this.selectDeviceData.occlusalClearance || this.selectDeviceDataInfo.occlusalClearance ? this.formData.get('occlusalClearance') : null,

        // exo
        innerCrownThickness: this.selectDeviceData.innerCrownThickness == 0 || this.selectDeviceData.innerCrownThickness ? this.formData.get('innerCrownThickness') : null,
        occlusionSpace: this.selectDeviceData.occlusionSpace == 0 || this.selectDeviceData.occlusionSpace ? this.formData.get('occlusionSpace') : null,
        adhesiveThickness: this.selectDeviceData.adhesiveThickness == 0 || this.selectDeviceData.adhesiveThickness ? this.formData.get('adhesiveThickness') : null,
        edgeHorizontalWidth: this.selectDeviceData.edgeHorizontalWidth == 0 || this.selectDeviceData.edgeHorizontalWidth ? this.formData.get('edgeHorizontalWidth') : null,
        edgeTiltWidth: this.selectDeviceData.edgeTiltWidth == 0 || this.selectDeviceData.edgeTiltWidth ? this.formData.get('edgeTiltWidth') : null,
        edgeInclinationAngle: this.selectDeviceData.edgeInclinationAngle == 0 || this.selectDeviceData.edgeInclinationAngle ? this.formData.get('edgeInclinationAngle') : null,
        edgeVerticalHeight: this.selectDeviceData.edgeVerticalHeight == 0 || this.selectDeviceData.edgeVerticalHeight ? this.formData.get('edgeVerticalHeight') : null,
        topAdhesiveWidth: this.selectDeviceData.topAdhesiveWidth == 0 || this.selectDeviceData.topAdhesiveWidth ? this.formData.get('topAdhesiveWidth') : null,
        axialExtraClearance: this.selectDeviceData.axialExtraClearance == 0 || this.selectDeviceData.axialExtraClearance ? this.formData.get('axialExtraClearance') : null,
        radialExtraClearance: this.selectDeviceData.radialExtraClearance == 0 || this.selectDeviceData.radialExtraClearance ? this.formData.get('radialExtraClearance') : null,
        crossSectionalAreaConnector: this.selectDeviceData.crossSectionalAreaConnector == 0 || this.selectDeviceData.crossSectionalAreaConnector ? this.formData.get('crossSectionalAreaConnector') : null,
        prohibitedFillingMargin: this.selectDeviceData.prohibitedFillingMargin == 0 || this.selectDeviceData.prohibitedFillingMargin ? this.formData.get('prohibitedFillingMargin') : null,
        gingivalThickness: this.selectDeviceData.gingivalThickness == 0 || this.selectDeviceData.gingivalThickness ? this.formData.get('gingivalThickness') : null,
        distanceAdjacentTooth: this.selectDeviceData.distanceAdjacentTooth == 0 || this.selectDeviceData.distanceAdjacentTooth ? this.formData.get('distanceAdjacentTooth') : null,
        marginLineShift: this.selectDeviceData.marginLineShift == 0 || this.selectDeviceData.marginLineShift ? this.formData.get('marginLineShift') : null,
        cementGap: this.selectDeviceData.cementGap == 0 || this.selectDeviceData.cementGap ? this.formData.get('cementGap') : null,
        fromMarginLine: this.selectDeviceData.fromMarginLine == 0 || this.selectDeviceData.fromMarginLine ? this.formData.get('fromMarginLine') : null,
        marginCementWidth: this.selectDeviceData.marginCementWidth == 0 || this.selectDeviceData.marginCementWidth ? this.formData.get('marginCementWidth') : null,

        isEditScanModel: this.formData.get('isEditScanModel'),
        designSoftware: this.designSoftware,
        dataScan: tempDataScan,
        dataSheet: tempDataSheet,
        dataMouth: tempDataMouth,
        dataCbct: tempDataCbct,
        dataScanRod: tempDataScanRod
      }
      // 判断额外适应症的id
      var id = orderData.servCataId
      var base1 = this.fund
      var base2 = this.quantity
      var count = orderData.orderCount
      if ((id == '1010210' || id == '1010220') && (base1 != 0 || base2 != 0)) {
        if (id == '1010210' && base1 > 0 && base2 > 0 && count > 0) {
          orderData.withServCataId = '1010120,1010220'
        } else if (id == '1010220' && base1 > 0 && base2 > 0 && count > 0) {
          orderData.withServCataId = '1010120,1010210'
        } else if (base1 == 0 && base2 > 0 && count > 0) {
          orderData.withServCataId = '1010120'
        } else if (id == '1010210' && base1 > 0 && base2 == 0 && count > 0) {
          orderData.withServCataId = '1010220'
        } else if (id == '1010220' && base1 > 0 && base2 == 0 && count > 0) {
          orderData.withServCataId = '1010210'
        } else {
          orderData.withServCataId = ''
        }
      } else if (id == '1010120' && (base1 != 0 || base2 != 0)) {
        var num1 = this.metal.length == 0 && this.quantity > 0 ? this.quantity : this.metal.length;
        var num2 = this.metal2.length == 0 && this.fund > 0 ? this.fund : this.metal2.length;
        if (num1 > 0 && num2 > 0) {
          orderData.withServCataId = '1010210,1010220'
        } else if (num1 == 0 && num2 > 0) {
          orderData.withServCataId = '1010220'
        } else if (num1 > 0 && num2 == 0) {
          orderData.withServCataId = '1010210'
        }
      } else if (id == '1010410') {
        orderData.withServCataId = this.withServCataId;
      } else {
        orderData.withServCataId = ''
      }
      // 上部冠没有复合适应症单独设置移除多余cam参数
      if (!orderData.withServCataId && this.subCatalogId == '1010120') {
        orderData.impSystem = ''
        orderData.impModel = ''
        orderData.impExtra = ''
        orderData.scanningRod = ''
        orderData.scanningRodSupplier = ''

        orderData.polymerization = ''
        orderData.baseHeight = ''
        orderData.shoulderWidth = ''
        orderData.shoulderAngle = ''
        orderData.supragingival = ''
      }
      // 基台没有复合适应症单独设置移除多余cam参数
      if (orderData.withServCataId == '' && ['1010210', '1010220'].includes(this.subCatalogId)) {
        this.form.adhesiveExtraGap = '';
        orderData.adhesiveExtraGap = '';
        orderData.adhesiveGap = '';
        orderData.minThick = '';
        orderData.wallHeight = '';
        orderData.edgeLineDistance = '';
        orderData.smoothDistance = '';
        orderData.burRadius = '';
        orderData.burGapOffset = '';
        orderData.edgeLineOffset = '';
        orderData.stretchOffset = '';
        orderData.angleOffset = '';
        orderData.occlusalClearance = '';
        orderData.adjacencyGap = '';
      }
      console.log('orderData', orderData);
      var msg = '您确定生成新订单?'
      if (this.isEditServOrder == '1') {
        let updateForm = ''
        if (sessionStorage.getItem('updateForm')) {
          updateForm = JSON.parse(sessionStorage.getItem('updateForm'))
        }
        orderData.servOrderId = this.$route.query.servOrderId
        orderData.orderStatus = updateForm.orderStatus
        orderData.continueDesignMsg = this.ruleForm.content
        sessionStorage.setItem("orderId", orderData.servOrderId)
        msg = '您将完成对服务单的修改,确定继续服务单【' + updateForm.servOrderNo + '】?'
        if (['1010699', '1010698'].includes(this.subCatalogId) && orderData.recessedRetentionAmount == null) {
          orderData.recessedRetentionAmount = '0'
        }
      }
      this.$confirm(msg, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.$api.post({
          url: '/biz/orderServ/dem/add?isEditServOrder=' + this.isEditServOrder,
          data: orderData
        }).then(res => {
          if (res.code == 200) {
            const editFlag = this.isEditServOrder;
            const orderId = sessionStorage.getItem('orderId');
            this.resetAfterSubmit();
            // 生成/修改成功后完整重置表单与缓存数据，避免返回后仍可继续生成
            this.clickReSelect();
            // removeSession会清空全部session，恢复服务单列表页所需的orderId
            if (orderId) {
              sessionStorage.setItem('orderId', orderId);
            }
            this.$yxz.msg(editFlag == '0' ? '生成订单成功' : '修改订单成功', 'success');
            this.$yxz.to('/order/dem');
          } else {
            this.$yxz.msg(res.msg);
            this.isSubmitting = false;
          }
        })
      }).catch(err => {
        this.isSubmitting = false
        if (err !== 'cancel') {
          console.error('提交失败:', err)
        }
      })
    },
    resetAfterSubmit() {
      this.metal = []
      this.metal2 = []
      this.montageStr = ''
      this.selectDeviceData = ''
      this.selectDeviceDataInfo = ''
      this.renovate = !this.renovate
      this.paramKey += 1
      this.ruleForm.content = ''
      this.loading = false
      this.msgDialog = false
      this.isSubmitting = false
    },
    open() {
      let id = this.subCatalogId
      let singList = this.singleDataList;
      let bridlist = this.bridgeDataList;
      let metal = this.metal;
      let metal2 = this.metal2;
      if (this.subCatalogId === '1010698' || this.subCatalogId === '1010699' || this.subCatalogId === '1010700') {
        this.currentStep += 1;
        sessionStorage.setItem('step', this.currentStep)
      } else {
        var str = '请再次确认制作' + singList + '单冠';
        if (bridlist && bridlist != '') {
          str = '请再次确认制作' + bridlist + '连桥'
        }
        if (singList && bridlist && singList != '' && bridlist != '') {
          str = '请再次确认制作' + singList + '单冠和' + bridlist + '连桥'
        }
        // 复合适应症提示
        if (['1010120'].includes(this.subCatalogId) && ['1010210', '1010220'].includes(this.withServCataId)) {
          let temp = str;
          str = `${temp}<br>种植上部冠牙位数量：${this.form.orderCount}<br>基台数量：${this.quantity}`;
        }
        // 基台提示
        if (['1010210', '1010220'].includes(id)) {
          str = `请再次确认制作 ${(id == '1010210' ? metal : metal2)} 基台`;
        }
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '重选',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.currentStep += 1;
          sessionStorage.setItem('step', this.currentStep)
        }).catch(() => {

        });
      }
    },
    openComposite() {
      let id = this.subCatalogId;
      let singList = this.singleDataList;
      let bridlist = this.bridgeDataList;
      let str = '';
      let temp = '请再次确认制作' + singList + '单冠';
      if (bridlist && bridlist != '') {
        temp = '请再次确认制作' + bridlist + '连桥'
      }
      if (singList && bridlist && singList != '' && bridlist != '') {
        temp = '请再次确认制作' + singList + '单冠和' + bridlist + '连桥'
      }
      if (['1010120'].includes(id) && (this.options2 || this.options3)) {
        str = `${temp}<br>种植上部冠牙位数量：${this.form.orderCount}<br>基台数量：${this.quantity}<br>
        <span style="color:#F57171;">请选择基台牙位</span>`;
      }
      if (['1010210', '1010220'].includes(id) && this.options1) {
        str = `请再次确认选择的牙位！<br>种植上部冠牙位数量：${this.quantity}<br>基台数量：${this.form.orderCount}<br>
        <span style="color:#F57171;">请选择种植上部修复冠牙位</span>`;
      }
      this.$alert(str, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: true
      }).then(() => {
        this.currentStep += 1;
        sessionStorage.setItem('step', this.currentStep)
      }).catch(() => {

      });
    },
    checkValid(currentStep) {
      //定义表单规则
      var rule = [{
        name: 'demContact',
        checkType: 'notnull',
        errorMsg: '请输入下单名称',
        isValid: '1'
      },
        {
          name: 'demPhone',
          checkType: 'phoneno',
          errorMsg: '请输入11位电话号码',
          isValid: '1'
        },
        {
          name: 'demPatient',
          checkType: "notnull",
          errorMsg: '请输入患者姓名',
          isValid: '1'
        },
        {
          name: 'demSex',
          checkType: "notnull",
          errorMsg: '请选择患者性别',
          isValid: '1'
        },
        {
          name: 'desLevel',
          checkType: 'notnull',
          errorMsg: '请选择设计师级别',
          isValid: this.user.demServType == '00' ? '1' : '0'
        },
        {
          name: 'orderCount',
          checkType: 'notnull',
          errorMsg: '请先选择牙位图',
          isValid: '1'
        },
        {
          name: 'plateType',
          checkType: 'notnull',
          errorMsg: '请先选择导板类型',
          isValid: this.cateserv.isPlate
        },
        {
          name: 'surgicalBoxSupplier',
          checkType: 'notnull',
          errorMsg: '请输入手术器械盒供应商',
          isValid: this.cateserv.isSurgicalBoxSupplier
        },
        {
          name: 'plantModel',
          checkType: 'notnull',
          errorMsg: '请输入导环规格和型号',
          isValid: this.cateserv.isPlantModel
        },
        // {
        //   name: 'impExtra',
        //   checkType: 'notnull',
        //   errorMsg: '请填写植体系统(其他)',
        //   isValid: (this.cateserv.isImpSystem == '1' && this.form.impSystem == '99') ? '1' : '0'
        // },
        {
          name: 'repairMaterial',
          checkType: "notnull",
          errorMsg: '请选择修复体材质',
          isValid: this.cateserv.isRepairMaterial
        },
        {
          name: 'impSystem',
          checkType: 'notnull',
          errorMsg: '请选择植体系统',
          isValid: this.cateserv.isImpSystem
        },
        {
          name: 'impModel',
          checkType: 'notnull',
          errorMsg: '请选择植体型号',
          isValid: this.cateserv.isImpModel
        },
        {
          name: 'scanningRod',
          checkType: 'notnull',
          errorMsg: '请选择扫描杆',
          isValid: this.cateserv.isScanningRod
        },
        {
          name: 'scanningRodSupplier',
          checkType: 'notnull',
          errorMsg: '请输入扫描杆供应商',
          isValid: this.cateserv.isScanningRodSupplier
        },
        {
          name: 'subgingival',
          checkType: 'notnull',
          errorMsg: '请输入精密附件及型号',
          isValid: this.cateserv.isSubgingival
        },
        {
          name: 'briCraft',
          checkType: 'notnull',
          errorMsg: '请选择桥架上部修复工艺',
          isValid: this.cateserv.isBriCraft
        },
        {
          name: 'collar',
          checkType: 'notnull',
          errorMsg: '请输入杆卡类型',
          isValid: this.cateserv.isCollar
        },
      ];
      var rule1 = [{
        name: 'dataType',
        checkType: 'notnull',
        errorMsg: '请选择数据类型',
        isValid: (this.cateserv.isDataType == '1' || (this.cateserv.isDeviceType == '1' && (this.user
          .demServType == '10' || this.user.demServType == '11'))) ? '1' : '0'
      },
        {
          name: 'softType',
          checkType: 'notnull',
          errorMsg: '请选择软件种类',
          isValid: (this.cateserv.isSoftType == '1' || (this.cateserv.isDeviceType == '1' && (this.user
              .demServType ==
            '10' || this.user.demServType == '11'))) ? '1' : '0'
        },
        {
          name: 'deviceType',
          checkType: 'notnull',
          errorMsg: '请选择设备型号',
          isValid: (this.cateserv.isDeviceType == '1' && (this.user.demServType == '10' || this.user.demServType ==
            '11')) ? '1' : '0'
        },
        // {
        //   name: 'dataScan',
        //   checkType: 'notnull',
        //   errorMsg: '请上传口扫数据',
        //   isValid: this.cateserv.isScanData == '1'
        // },
        {
          name: 'deviceType',
          checkType: 'notnull',
          errorMsg: '请选择CAM制造机名称',
          isValid: this.cateserv.isDevecieValidate == '1'
        },
        // {
        //   name: 'dataCbct',
        //   checkType: 'notnull',
        //   errorMsg: '请上传CBCT数据',
        //   isValid: this.cateserv.isCbctData == '1'
        // }
      ]

      //isValid字段判断是否需要效验，isValid等于1需要效验，否则不需要效验
      var tempRule = rule.filter((item) => {
        return item.isValid == '1'
      })
      var tempRule1 = rule1.filter((item) => {
        return item.isValid == '1'
      })
      //进行表单检查
      var formData = {
        demContact: this.form.demContact,
        demPhone: this.form.demPhone,
        demPatient: this.form.demPatient,
        demSex: this.form.demSex,
        desLevel: this.form.desLevel,
        orderCount: this.form.orderCount,
        plateType: this.form.plateType,
        impSystem: this.form.impSystem,
        impModel: this.form.impModel,
        impExtra: this.form.impExtra,
        scanningRod: this.form.scanningRod,
        scanningRodSupplier: this.form.scanningRodSupplier,
        subgingival: this.form.subgingival,
        surgicalBoxSupplier: this.form.surgicalBoxSupplier,
        plantModel: this.form.plantModel,
        deviceType: this.form.deviceType,
        briCraft: this.form.briCraft,
        collar: this.form.collar,
        minThick: this.form.minThick,
        dataType: this.form.dataType,
        softType: this.form.softType,
        dataScan: this.dataScan,
        dataSheet: this.dataSheet,
        dataMouth: this.dataMouth,
        dataCbct: this.dataCbct,
        repairMaterial: this.form.repairMaterial,
      }
      if (currentStep == 2) {
        var checkRes = graceChecker.check(formData, tempRule);
        if (!checkRes) {
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      } else if (currentStep == 3) {
        var checkRes = graceChecker.check(formData, tempRule1);
        if (!checkRes) {
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      }
      return false
    },
    // 重置信息
    resetForm() {
      this.currentCatalog = -1;
      this.currentSubCatalog = -1;
      this.subCatalogList = [];
      this.form.demPatient = ''
      this.form.desLevel = '';
      this.form.orderCount = 0;
      this.form.orderPrice = 0.00;
      this.form.toothCountAll = 0;
      this.form.orderRushFee = 0.00;
      this.form.orderAmount = 0.00;
      this.form.orderRemark = '';
      this.form.softType = '';
      this.form.dataType = '';
      this.form.posSingle = '';
      this.form.posBridge = '';
      this.form.posHole = '0';
      this.form.plateType = '';
      this.form.impSystem = '';
      this.form.impModel = '';
      this.form.impExtra = '';
      this.form.scanningRod = '';
      this.form.scanningRodSupplier = '';
      this.form.subgingival = '';
      this.form.surgicalBoxSupplier = '';
      this.form.plantModel = '';
      this.form.deviceType = '';
      this.form.briCraft = '';
      this.form.collar = '';
      this.form.repairMaterial = '';
      this.form.gingiva = '01'; //牙龈位置
      this.form.shoulderPosition = '01'; //肩台位置

      this.form.adhesiveGap = 0.003; //黏着剂间隙
      this.form.adhesiveExtraGap = 0.04; //额外黏着剂间隙：0.04mm
      this.form.minThick = 0.6; //最小厚度：0.6mm
      this.form.wallHeight = 0.8; //壁高度：0.8mm
      this.form.edgeLineDistance = 1; //到边缘线的距离：1mm
      this.form.smoothDistance = 0.2; //平滑距离 = 0.2mm
      this.form.burRadius = 0.5; //车针半径  = 0.5mm
      this.form.burGapOffset = 0.52; //车针补偿间距 = 0.52mm
      this.form.edgeLineOffset = 0.15; //边缘线补偿 = 0.15mm
      this.form.stretchOffset = 0.1; //延伸补偿 =0.1mm
      this.form.angleOffset = 60; //补偿角度 =25-60度
      this.form.isTongueSide = '0'; //舌侧边补偿（宽度）0=无,1=有
      this.form.sideOffset = '0'; //舌侧边补偿参数
      this.form.tongueSideOffset = 1; //舌侧边 1mm
      this.form.circleSideOffset = 1; //360度边1mm
      this.form.polymerization = 6; //聚合度 6度
      this.form.baseHeight = 4.5;
      this.form.shoulderWidth = 1;
      this.form.shoulderAngle = 120;
      this.form.supragingival = 1.0; //龈下参数

      this.formData = "";
      this.dataScan = [];
      this.dataSheet = [];
      this.dataMouth = [];
      this.dataCbct = [];
      this.fileList = [];
      this.dataScanRod = [];
      this.singleDataList = [];
      this.bridgeDataList = [];
      this.metal = [];
      this.metal2 = [];
      this.cateserv = null;
      this.isEditServOrder = '0'
      this.isShowTemplate = false
    },
    change1() {
      this.colorContact = '#2979ff'
    },
    change2() {
      this.colorPhone = '#2979ff'
    },
    change3() {
      this.colorPatient = '#2979ff'
    },
    // 上传文件查看示例的dialog状态改变
    changeOralDis() {
      this.dialogStatue = true;
      if (this.dialogStatue == true) {
        this.dialogNum += 1;
        if (this.dialogNum != 0) {
          this.oralUpload = false
        }
      }
    },
    changeCBCTDis() {
      this.CBCTdialog = true;
      if (this.CBCTdialog == true) {
        this.CBCTNum += 1;
        if (this.CBCTNum != 0) {
          this.CBCTUpload = false
        }
      }
    },
    changeCBCTDis1() {
      this.CBCTdialog1 = true;
      if (this.CBCTdialog1 == true) {
        this.CBCTNum1 += 1;
        if (this.CBCTNum1 != 0) {
          this.CBCTUpload1 = false
        }
      }
    },
    changeCBCTDis2() {
      this.CBCTdialog2 = true;
      if (this.CBCTdialog2 == true) {
        this.CBCTNum2 += 1;
        if (this.CBCTNum2 != 0) {
          this.CBCTUpload2 = false
        }
      }
    },
    oralTip() {
      if (this.oralUpload == true) {
        this.$yxz.msg("请完成示例查看后上传文件。", 'warning', 4000, {
          customClass: 'adv-message'
        })
      }
    },
    CBCT1Tip() {
      if (this.CBCTUpload == true) {
        this.$yxz.msg('请完成示例查看后上传文件。', 'warning', 4000, {
          customClass: 'adv-message'
        })
      }
    },
    CBCT2Tip() {
      if (this.CBCTUpload1 == true) {
        this.$yxz.msg('请完成示例查看后上传文件。', 'warning', 4000, {
          customClass: 'adv-message'
        })
      }
    },
    CBCT3Tip() {
      if (this.CBCTUpload2 == true) {
        this.$yxz.msg('请完成示例查看后上传文件。', 'warning', 4000, {
          customClass: 'adv-message'
        })
      }
    },
    //获取植体系统
    getSystem(impSystem) {
      this.impModelList = []
      var tempList = []
      for (let i = 0; i < this.common.implList.length; i++) {
        if (parseInt(impSystem) - 1001 == i) {
          tempList = this.common.implList[i].children;
          for (let j = 0; j < tempList.length; j++) {
            this.impModelList.push(tempList[j])
          }
        }
        this.impModelListTemp = this.impModelList;
        if (this.form.impSystem == this.common.implList[i].implId) {
          this.form.impSystem = this.common.implList[i].implName
        }
      }
    },
    //获取植体型号
    getModel() {
      for (let i = 0; i < this.common.implList.length; i++) {
        for (let j = 0; j < this.common.implList[i].children.length; j++) {
          if (this.form.impModel == this.common.implList[i].children[j].implId) {
            this.form.impModel = this.common.implList[i].children[j].implName
          }
        }
      }
    },
    //从会话存储中加载数据。
    loadFormSession(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null ? value : defaultValue;
    },
    //
    loadFormSessionJSON(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null && value !== '' && value !== undefined && value !== 'undefined' ? JSON.parse(value) : defaultValue;
    },
    // 统一调用session缓存
    getData() {
      this.$api.get({
        url: '/user/checkLogin'
      }).then(res => {
        this.$store.commit('common/recordDict', res.data.dictList)
        this.$store.commit('common/recordServCata', res.data.servList)
        this.$store.commit('common/recordImplDict', res.data.implList)
      })
      if (this.isEditServOrder == '1') {
        this.subCatalogId = this.loadFormSessionJSON('updateForm', '').servCataId;
      } else {
        this.subCatalogId = this.loadFormSession('subCatalogId', '');
      }
      if (this.subCatalogId) {
        this.nextStep = true
      }
      this.currentStep = parseInt(this.loadFormSession('step', 1));
      this.upperZero = this.loadFormSessionJSON('upperZero', false);
      this.plateZero = this.loadFormSessionJSON('plateZero', false);
      this.datalists = this.loadFormSessionJSON('datalists', []);
      this.devicelists = this.loadFormSessionJSON('devicelists', []);
      this.addatalists = this.loadFormSessionJSON('addatalists', []);
      this.addevicelists = this.loadFormSessionJSON('addevicelists', []);
      this.selectDeviceData = this.loadFormSessionJSON('selectDeviceData', '');
      this.selectDeviceDataInfo = this.loadFormSessionJSON('selectDeviceDataInfo', '');
      this.catalogId = this.loadFormSession('catalogId', '');
      this.isTonguesideShow = this.loadFormSession('isTonguesideShow', false);
      this.catalogTitle = this.loadFormSession('catalogTitle', '');
      this.withServCataId = this.loadFormSession('withServCataId', this.withServCataId);
      this.options1 = this.loadFormSessionJSON('options1', false);
      this.options2 = this.loadFormSessionJSON('options2', false);
      this.options3 = this.loadFormSessionJSON('options3', false);
      this.servBridge = this.loadFormSessionJSON('servBridge', false);
      this.servCataTemp = this.loadFormSessionJSON('servCataTemp', []);
      this.remarkHistory = localStorage.getItem('remarkHistory') ? JSON.parse(localStorage.getItem('remarkHistory')) : [];
      this.form = this.isEditServOrder == '1' ? this.loadFormSessionJSON('updateForm', this.form) : this.loadFormSessionJSON('form', this.form);
      this.metal = this.loadFormSessionJSON('metal', []);
      this.metal2 = this.loadFormSessionJSON('metal2', []);
      this.montageStr = this.loadFormSessionJSON('montageStr', '');
      this.editModelFee = this.isEditServOrder == '1' && this.form.isEditScanModel == '1' ? this.common.serv.get(this.subCatalogId).editScanModelBprice : this.loadFormSession('editModelFee', 0.00);
      this.upSelect = this.loadFormSession('upSelect', 0);
      this.downSelect = this.loadFormSession('downSelect', 0);
      this.metalUp = this.loadFormSession('metalUp', 0);
      this.metalDown = this.loadFormSession('metalDown', 0);
      this.isCreate = this.loadFormSessionJSON('isCreate', false);
      this.templateOptions = this.loadFormSessionJSON('templatOption', []);
      this.cateserv = this.loadFormSessionJSON('cateserv', []);
      this.templateItem = this.loadFormSession('templateItem', '9999')
      this.camParamList = this.loadFormSessionJSON('camParamList', []);

      if (this.isEditServOrder == '0') {
        this.dataCbct = this.loadFormSessionJSON('dataCbct', this.dataCbct);
        this.dataScan = this.loadFormSessionJSON('dataScan', this.dataScan);
        this.dataSheet = this.loadFormSessionJSON('dataSheet', this.dataSheet);
        this.dataMouth = this.loadFormSessionJSON('dataMouth', this.dataMouth);
        this.dataScanRod = this.loadFormSessionJSON('dataScanRod', this.dataScanRod);
      } else if (this.isEditServOrder == '1') {
        let order = this.loadFormSessionJSON('updateForm', [])
        this.dataCbct = this.loadFormSessionJSON('dataCbct', JSON.parse(order.dataCbct));
        this.dataScan = this.loadFormSessionJSON('dataScan', JSON.parse(order.dataScan))
        this.dataSheet = this.loadFormSessionJSON('dataSheet', JSON.parse(order.dataSheet));
        this.dataMouth = order.dataMouth != '' ? this.loadFormSessionJSON('dataMouth', JSON.parse(order.dataMouth)) : [];
        this.dataScanRod = this.loadFormSessionJSON('dataScanRod', JSON.parse(order.dataScanRod));
      }
      this.handleFormData()
      // 使用模版后刷新重新赋值设备参数
      if (this.templateItem != '9999') {
        this.changeTemplate()
      }
    },
    //获取session数据后，处理这些数据
    handleFormData() {
      // 重新计算牙位数量
      let id = this.subCatalogId;
      if (this.form && this.subCatalogId) {
        // 重置牙位数量、总价
        this.singleDataList = this.isEditServOrder == '1' ? this.form.posSingleList : (this.form.posSingle == '' ? [] : this.form.posSingle)
        this.bridgeDataList = this.isEditServOrder == '1' ? this.form.posBridgeList : (this.form.posBridge == '' ? [] : this.form.posBridge)
        if (['1010210', '1010220', '1010410'].includes(id) && this.withServCataId == '1010120') {
          this.form.addeviceType = this.form.deviceType
        }
        // 按servCataId计算牙位
        this.conditionCount(id);
        // 计算总价
        this.calAmount();
      }
    },
    // 重新获取设备参数
    handleSelectData() {
      let id = this.subCatalogId;
      this.datalists.forEach(val => {
        if (val.deviceType == this.form.deviceType) {
          // if(id == '1010210'||id == '1010220'){
          // 主适应症的设备参数
          this.selectDeviceData = val
          // }
        }
      })
      let wid = this.withServCataId.includes('1010210') || this.withServCataId.includes('1010220') ? '1010210' : this.withServCataId
      if (this.withServCataId.includes('1010120')) {
        wid = '1010120'
      }
      this.templateParam(id, this.selectDeviceData, this.form)
      // 判断selectDeviceData和selectDeviceDataInfo是否有数据
      if (id == '1010120' && this.selectDeviceDataInfo == '' && this.withServCataId != '0') {
        this.selectDeviceDataInfo = this.camParamList[0].children[14]
      } else if (['1010210', '1010220', '1010410'].includes(id) && this.selectDeviceDataInfo ==
        '' && this.withServCataId != '0') {
        this.infoParamInfo(0, wid)
      }
      if (wid == '' || wid == '0') {
        this.templateParam(wid, this.selectDeviceDataInfo, this.form)
        if (id == '1010120') {
          this.form.polymerization = ''
          this.form.baseHeight = ''
          this.form.shoulderWidth = ''
          this.form.shoulderAngle = ''
          this.form.supragingival = ''
        } else if (id == '1010210' || id == '1010220') {
          this.form.adhesiveExtraGap = ''
          this.form.adhesiveGap = ''
          this.form.minThick = ''
          this.form.wallHeight = ''
          this.form.edgeLineDistance = ''
          this.form.smoothDistance = ''
          this.form.burRadius = ''
          this.form.burGapOffset = ''
          this.form.edgeLineOffset = ''
          this.form.stretchOffset = ''
          this.form.angleOffset = ''
          this.form.occlusalClearance = ''
          this.form.adjacencyGap = ''
        }
      } else {
        this.templateParam(wid, this.form, this.selectDeviceDataInfo, 1);
      }
    },
    //参数模版 上部冠/基台
    //list2(传form)，list1(传selectDeviceData)--对应设备参数list
    // 传1不移除基台参数
    templateParam(id, list1, list2, flag) {
      if (!list1 || typeof list1 !== 'object' || Array.isArray(list1)) {
        list1 = {};
      }
      flag = flag == 1 ? false : true;
      // 上部冠参数传递
      if (id == '1010120' || id == '2010120' || id == '2010210' ||
        id == '2010220' || id == '2010320' || id == '2010420') {
        list1.adhesiveExtraGap = list2.adhesiveExtraGap
        list1.adhesiveGap = list2.adhesiveGap
        list1.minThick = list2.minThick
        list1.wallHeight = list2.wallHeight
        list1.edgeLineDistance = list2.edgeLineDistance
        list1.smoothDistance = list2.smoothDistance
        list1.burRadius = list2.burRadius
        list1.burGapOffset = list2.burGapOffset
        list1.edgeLineOffset = list2.edgeLineOffset
        list1.stretchOffset = list2.stretchOffset
        list1.angleOffset = list2.angleOffset
        list1.occlusalClearance = list2.occlusalClearance
        list1.adjacencyGap = list2.adjacencyGap
        // exo参数
        list1.innerCrownThickness = list2.innerCrownThickness
        list1.occlusionSpace = list2.occlusionSpace
        list1.adhesiveThickness = list2.adhesiveThickness
        list1.axialExtraClearance = list2.axialExtraClearance
        list1.edgeHorizontalWidth = list2.edgeHorizontalWidth
        list1.edgeTiltWidth = list2.edgeTiltWidth
        list1.edgeInclinationAngle = list2.edgeInclinationAngle
        list1.edgeVerticalHeight = list2.edgeVerticalHeight
        list1.topAdhesiveWidth = list2.topAdhesiveWidth
        list1.radialExtraClearance = list2.radialExtraClearance
        list1.crossSectionalAreaConnector = list2.crossSectionalAreaConnector
        list1.prohibitedFillingMargin = list2.prohibitedFillingMargin
        list1.gingivalThickness = list2.gingivalThickness
        list1.distanceAdjacentTooth = list2.distanceAdjacentTooth
        list1.marginLineShift = list2.marginLineShift
        list1.cementGap = list2.cementGap
        list1.fromMarginLine = list2.fromMarginLine
        list1.marginCementWidth = list2.marginCementWidth
        // remove基台的参数
        if (flag) {
          list1.polymerization = 0
          list1.baseHeight = 0
          list1.shoulderWidth = 0
          list1.shoulderAngle = 0
          list1.supragingival = 0
        }
        if (id == '2010220' || id == '2010210') {
          list1.circleSideOffset = list2.circleSideOffset
          list1.tongueSideOffset = list2.tongueSideOffset
        }
        // this.renovate = !this.renovate
      }
      // 基台参数传递
      if (id == '1010210' || id == '1010220') {
        list1.polymerization = list2.polymerization
        list1.baseHeight = list2.baseHeight
        list1.shoulderWidth = list2.shoulderWidth
        list1.shoulderAngle = list2.shoulderAngle
        list1.supragingival = list2.supragingival
        // this.paramKey +=1
      }
      // 基台一体冠
      if (id == '1010310' || id == '1010320') {
        list1.occlusalClearance = list2.occlusalClearance
        list1.adjacencyGap = list2.adjacencyGap
      }
      if (id == '1010698' || id == '1010699') {
        list1.plateThickness = list2.plateThickness
        list1.teethModelDeviation = list2.teethModelDeviation
        list1.recessedRetentionAmount = list2.recessedRetentionAmount
        list1.guideRingCompensatio = list2.guideRingCompensatio
      }
      // 改变key，视图同步参数
      if (this.withServCataId == '' || this.withServCataId == '0') {
        this.renovate = !this.renovate
      } else {
        this.renovate = !this.renovate
        this.paramKey += 1
      }
      sessionStorage.setItem('selectDeviceData', JSON.stringify(this.selectDeviceData))
      sessionStorage.setItem('selectDeviceDataInfo', JSON.stringify(this.selectDeviceDataInfo))
    },
    // 移除session存储的数据
    removeSession() {
      sessionStorage.removeItem('catalogTitle')
      sessionStorage.removeItem('subCatalogId')
      sessionStorage.removeItem('step')
      sessionStorage.removeItem('form')
      sessionStorage.removeItem('devicelists')
      sessionStorage.removeItem('addevicelists')
      sessionStorage.removeItem('selectDeviceData')
      sessionStorage.removeItem('catalogId')
      sessionStorage.removeItem('datalists')
      sessionStorage.removeItem('addatalists')
      sessionStorage.removeItem('serv')
      sessionStorage.removeItem('isTonguesideShow')
      sessionStorage.removeItem('metal')
      sessionStorage.removeItem('metal2')
      sessionStorage.removeItem('withServCataId')
      sessionStorage.removeItem('servBridge')
      sessionStorage.removeItem('servCataTemp')
      sessionStorage.removeItem('options1')
      sessionStorage.removeItem('options2')
      sessionStorage.removeItem('options3')
      sessionStorage.removeItem('upperZero')
      sessionStorage.removeItem('plateZero')
      sessionStorage.removeItem('montageStr')
      sessionStorage.clear()
    },
    //新增表单规则
    setIs() {
      this.common.serv.get('1010510').isCollar = '1'
      this.common.serv.get('2010210').isCollar = '0'
      this.common.serv.get('2010220').isCollar = '0'
      this.common.serv.get('1010510').isBriCraft = '0'
      this.common.serv.get('1010699').isPlantModel = '1'
      this.common.serv.get('1010698').isPlantModel = '1'
      this.common.serv.get('1010510').isSubgingival = '1'
      this.common.serv.get('1010120').isRepairMaterial = '1'
      this.common.serv.get('1010698').isSurgicalBoxSupplier = '1'
      this.common.serv.get('1010699').isSurgicalBoxSupplier = '1'
      // 扫描杆规则
      let scanRodList = ['1010210', '1010220', '1010310', '1010320', '1010410', '1010510']
      scanRodList.forEach(val => {
        this.common.serv.get(val).isScanningRod = '1'
      })
      //扫描杆供应商规则
      let scanRodSupList = ['1010510', '1010410', '1010210', '1010220', '1010310', '1010320']
      scanRodSupList.forEach(val => {
        this.common.serv.get(val).isScanningRodSupplier = '1'
      })
      // 植体型号规则
      let implList = ['1010698', '1010699', '1010310', '1010320', '1010510']
      implList.forEach(val => {
        this.common.serv.get(val).isImpModel = '1'
      })
      // cam制造机规则
      let camList = ['1010120', '1010698', '1010699', '2010120', '2010220', '2010320', '2010420']
      camList.forEach(val => {
        this.common.serv.get(val).isDevecieValidate = '1'
      })
    },
    // 添加表单规则
    addIs() {
      let id = this.subCatalogId;
      if (id == null || id == '') {
        return false
      }
      // 额外
      if (this.fund > 0 || this.quantity > 0 || this.options2 || this.options3) {
        this.common.serv.get(id).isImpSystem = '1'
        this.common.serv.get(id).isImpModel = '1'
        this.common.serv.get(id).isScanningRod = '1'
        this.common.serv.get(id).isScanningRodSupplier = '1'
        this.cateserv.isImpSystem = '1'
        this.cateserv.isImpModel = '1'
        this.cateserv.isScanningRod = '1'
        this.cateserv.isScanningRodSupplier = '1'
      }
      if (id == '1010120' && this.fund == 0 && this.quantity == 0 && this.options2 == false && this.options3 == false) {
        this.common.serv.get(id).isImpSystem = '0'
        this.common.serv.get(id).isImpModel = '0'
        this.common.serv.get(id).isScanningRod = '0'
        this.common.serv.get(id).isScanningRodSupplier = '0'
        this.cateserv.isImpSystem = '0'
        this.cateserv.isImpModel = '0'
        this.cateserv.isScanningRod = '0'
        this.cateserv.isScanningRodSupplier = '0'
        this.form.impModel = ''
        this.form.impSystem = ''
        this.form.scanningRod = ''
        this.form.scanningRodSupplier = ''
      }
      if (['1010210', '1010220'].includes(id) && this.quantity > 0) {
        this.common.serv.get(id).isRepairMaterial = '1'
        this.cateserv.isRepairMaterial = '1'
      }
      if (['1010210', '1010220'].includes(id) && this.quantity == 0 && this.options1 == false) {
        this.cateserv.isRepairMaterial = '0'
        this.common.serv.get(id).isRepairMaterial = '0'
        this.form.repairMaterial = ''
      }
      if (['1010410'].includes(id) && this.quantity > 0) {
        this.cateserv.isRepairMaterial = '1'
        this.common.serv.get(id).isRepairMaterial = '1'
      }
      if (['1010410'].includes(id) && this.quantity <= 0) {
        this.cateserv.isRepairMaterial = '0'
        this.common.serv.get(id).isRepairMaterial = '0'
      }
    },
    // 移除表单规则
    removeIs() {
      var id = this.subCatalogId
      if (id == '1010120') {
        this.common.serv.get(id).isImpSystem = '0'
        this.common.serv.get(id).isImpModel = '0'
        this.common.serv.get(id).isScanningRod = '0'
        this.common.serv.get(id).isScanningRodSupplier = '0'
        this.form.impModel = ''
        this.form.impSystem = ''
        this.form.scanningRod = ''
        this.form.scanningRodSupplier = ''
      } else if (((id == '1010210' || id == '1010220') && this.withServCataId !== '1010120') || id == '1010410') {
        this.common.serv.get(id).isRepairMaterial = '0'
        this.common.serv.get(id).isRepairMaterial = '0'
        this.form.repairMaterial = ''
      }
      this.common.serv.get('1010700').isImpSystem = '0'
      this.common.serv.get('1010700').isImpModel = '0'
      if (id == '1010700') {
        this.cateserv.isImpSystem = '0'
        this.cateserv.isImpModel = '0'
      }
    },
    // 修改订单，读取订单详情信息和设置订单步骤环境
    loadingup() {
      // 在session中获取详情订单数据
      if (sessionStorage.getItem('updateForm')) {
        this.oralUpload = false;
        this.CBCTUpload = false;
        this.CBCTUpload1 = false;
        this.CBCTUpload2 = false;
        var orderDetail = JSON.parse(sessionStorage.getItem('updateForm'))
        this.designSoftware = orderDetail.designSoftware;
        this.catalogId = orderDetail.servCataId.slice(0, 2);
        this.subCatalogId = orderDetail.servCataId
        var id = this.subCatalogId
        JSON.parse(orderDetail.dataScan).forEach((val, i) => {
          this.dataScan.push(val)
        })
        JSON.parse(orderDetail.dataScanRod).forEach((val, i) => {
          this.dataScanRod.push(val)
        })
        JSON.parse(orderDetail.dataCbct).forEach((val, i) => {
          this.dataCbct.push(val)
        })
        this.getTemplateList()
        this.showBridgeBtn(id)
        this.choiceOptions(id)

        this.singleDataList = orderDetail.posSingleList
        this.bridgeDataList = orderDetail.posBridgeList
        this.forKey(orderDetail, this.form)
        this.nextStep = true
        this.isEditServOrder = '1'
        this.catalogTitle = orderDetail.servName
        // 额外适应症选择牙齿的数量
        // 基台数量
        if (id !== '1010410' && orderDetail.withServCataId) {
          this.form.posSingle = this.singleDataList ? this.singleDataList.join(',') : '';
          this.fund = (this.form.posSingle.match(/~/g) || []).length;
          // 上部冠/基台数量
          this.quantity = (this.form.posSingle.match(/\^/g) || []).length;
          // 额外适应症选择的单价
          if ((id == '1010210' || id == '1010220') && this.fund > 0) {
            this.basePrice = this.form.orderPrice
          } else {
            this.basePrice = this.countPrice(this.withServCataId, this.form.desLevel)
          }
          this.extraUnitPrice = this.countPrice(this.withServCataId, this.form.desLevel)
        }
        this.withServCataId = orderDetail.withServCataId
        this.cateserv = this.common.serv.get(id)
        this.titleStr()
        if (this.user.demServType == '00') {
          this.isLevel = true
        } else {
          this.isLevel = false
        }
        sessionStorage.setItem('catalogId', this.catalogId)
      }
    },
    //修改服务单时，拼接服务单类型的字符串
    titleStr() {
      let arr1 = ['1010120', '1010210', '1010220', '1010310', '1010320', '1010410', '1010510', '1010698', '1010699',
        '1010700'
      ]
      let arr2 = ['2010120', '2010210', '2010220', '2010320', '2010420']
      let arr3 = ['3010130']
      let arr4 = ['4010110']
      if (arr1.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化种植修复' + ' - ' + this.cateserv.servName
      } else if (arr2.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化固定修复' + ' - ' + this.cateserv.servName
      } else if (arr3.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化正畸修复' + ' - ' + this.cateserv.servName
      } else if (arr4.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化活动修复' + ' - ' + this.cateserv.servName
      }
      sessionStorage.setItem('catalogTitle', this.catalogTitle)
    },
    // 形参合并相同元素给list2，修改订单：订单详情参数合并给form
    forKey(list1, list2) {
      for (const key1 in list1) {
        for (const key2 in list2) {
          if (key1 === key2) {
            list2[key2] = list1[key2]
          }
        }
      }
    },
    /**
     * 计算额外适应症单价
     *
     * @param {string} id - 适应症服务单类型ID
     * @param {string} level - 设计师级别
     * @returns {fload} - 返回适应症单价
     */
    countPrice(id, level) {
      var price = 0.00;
      let ids = id.split(',').includes('1010120') ? '1010120' : id;
      this.common.serv.forEach((val, key) => {
        if (ids == key) {
          switch (level) {
            case '01':
              price = val.ftyBpricePri;
              break;
            case '02':
              price = val.ftyBpriceMid;
              break;
            case '03':
              price = val.ftyBpriceSen;
              break;
            default:
              price = val.clnBprice;
              break;
          }
          price = this.user.demServType == '00' ? price : val.clnBprice;
        }
      })
      return price;
    },
    /**
     * 获取适应证服务单类型ID
     *
     * @returns {string} - 返回适应证服务单类型ID
     */
    withId(num1, num2) {
      let id = this.subCatalogId;
      let tempId = '0';
      let flag = false;
      let bridge = this.bridgeDataList ? this.bridgeDataList : [];
      let single = this.singleDataList ? this.singleDataList : [];
      if (this.singleDataList != [] && this.singleDataList != '' && this.singleDataList != undefined) {
        this.singleDataList.forEach(val => {
          val += ''
          if (!val.includes('~') && !val.includes('^') && val !== '') {
            flag = true
          }
        })
      } else if (bridge.length > 0) {
        flag = true
      }
      if (id == '1010120' && num1 > 0) {
        tempId = '1010210';
      } else if (id == '1010120' && num2 > 0) {
        tempId = '1010220';
      } else if (id == '1010210') {
        if (num2 > 0 && bridge.length == 0 && single.length == 0) {
          tempId = '1010220';
        } else if ((bridge.length > 0 || single.length > 0) && flag) {
          tempId = '1010120';
        } else {
          tempId = ''
        }
      } else if (id == '1010220') {
        if (num1 > 0 && bridge.length == 0 && single.length == 0) {
          tempId = '1010210';
        } else if ((bridge.length > 0 || single.length > 0) && flag) {
          tempId = '1010120';
        } else {
          tempId = ''
        }
      } else if (id == '1010410' && (bridge.length > 0 || single.length > 0)) {
        tempId = '1010120';
      }
      return tempId;
    },
    // 改变复合适应症的选项，修改对应状态
    checkChange(index) {
      // 状态判断，两个基台不能同时选中
      if (index == 2 && this.options2) {
        this.options2 = true
        this.options3 = false
      } else if (index == 3 && this.options3) {
        this.options3 = true
        this.options2 = false
      } else if (index == 4) {
        this.options1 = false
        this.options2 = false
        this.options3 = false
      }
    },
    // 在组件挂载DOM树后加载
    think() {
      var id = this.subCatalogId
      var userType = this.user.demServType
      document.title = "医小智 - 服务单";
      window.addEventListener('beforeunload', () => {
        if (this.currentStep != 1) {
          if (this.currentStep == '2') {
            this.loadingup()
          }
          if (this.prohibit == false && id != '3010130') {
            sessionStorage.setItem('form', JSON.stringify(this.form));
          }
        }
        if (this.metal != '' || this.metal2 != '') {
          sessionStorage.setItem('metal', JSON.stringify(this.metal))
          sessionStorage.setItem('metal2', JSON.stringify(this.metal2))
        }
        // 刷新前处理复合选项的牙位（拼接单冠和复合牙位）,下一步也会调用此方法
        this.handleComposite()
      });
      // 没有服务类型下一步状态为false
      if (!sessionStorage.getItem('subCatalogId') && !this.subCatalogId) {
        this.nextStep = false
      }
    },
    // // 判断是否显示设计师级别
    // addClass() {
    //   var id = this.subCatalogId
    //   var userType = this.user.demServType
    //   this.$nextTick(() => {
    //     // 显示设计师级别
    //     if (userType == '00' &&
    //       (id == '1010120' || id == '1010210' ||
    //         id == '1010220' || id == '1010310' ||
    //         id == '1010320' || id == '2010120' ||
    //         id == '2010210' || id == '2010220' ||
    //         id == '2010320' || id == '2010420')) {
    //       this.isLevel = true
    //     }
    //   })
    // },
    // 点击历史替换备注
    replaceStr(index) {
      this.form.orderRemark = this.remarkHistory[index]
    },
    // 移除历史备注项
    removeItem(index) {
      this.remarkHistory.splice(index, 1)
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    /**
     * 初始化子目录显示
     */
    loadSubCatalogByCatalogId() {
      if (this.$route.query.catalogId) {
        this.currentCatalog = Number(this.$route.query.catalogId)
        this.getSubCatalogList(this.currentCatalog)
      }
    },
    /**
     * 获取子目录列表
     * @param {string} currentCatalogIndex - 当前主目录索引
     */
    getSubCatalogList(currentCatalogIndex) {
      // 获取当前主目录的子目录列表
      var tempList = this.catalogList[currentCatalogIndex].subCataLog;
      // 非工厂端，移除工厂端子目录
      if (currentCatalogIndex === 0 && this.user.demServType !== '00') {
        // 种植修复，移除杆卡
        tempList.splice(9, 2);
      } else if (currentCatalogIndex === 1 && this.user.demServType !== '00') {
        // 固定修复，过滤特定子目录
        for (let i = tempList.length - 1; i >= 0; i--) {
          if (tempList[i].subCatalogId === '2010210' || tempList[i].subCatalogId === '2010220') {
            tempList.splice(i, 1);
          }
        }
      }
      this.subCatalogList = tempList; // 更新子目录列表
      this.currentSubCatalog = -1; // 重置子目录选择
    },
    // 生成模版打开dialog
    createTempate() {
      if (this.templateOptions.length >= 6) {
        this.$yxz.msg("生成模版上限为5种，请先移除一种。", 'warning', 4000, {
          customClass: 'adv-message',
        })
        return false
      }
      this.templateDialog = true;
      this.isEditTemplate = '0'
      this.$refs.select.blur();
    },
    //模版组件关闭dialog
    changeDialog(flag, str) {
      this.isEditTemplate = str
      this.templateDialog = flag
      this.getTemplateList()
      this.editDeviceParam = ''
    },
    // 获取模版列表
    getTemplateList() {
      if (this.currentStep != 1) {
        this.$api.get({
          url: '/business/template/list?servCataId=' + this.subCatalogId
        }).then(res => {
          this.templateOptions = res.data
          let temp = {
            id: '9999',
            title: '不使用模版',
          }
          this.templateOptions.push(temp)
          sessionStorage.setItem('templatOption', JSON.stringify(this.templateOptions))
        })
      }
    },
    // 判断显示模版
    showTemplate() {
      let id = this.subCatalogId
      if (id == '1010700' || id == '1010410' || id == '1010510') {
        this.isShowTemplate = false
      } else {
        this.isShowTemplate = true
      }
    },
    // 切换设计软件
    changeSoftware() {
      // 判断选择的值，赋值exo还是cam
      if (this.designSoftware == '10') {
        for (let i = 0; i < this.camParamList.length; i++) {
          if (this.camParamList[i].servCode == '90') {
            this.selectDeviceData = this.camParamList[i]
          }
        }
      } else {
        for (let i = 0; i < this.datalists.length; i++) {
          if (this.datalists[i].deviceType == this.form.deviceType) {
            this.selectDeviceData = this.datalists[i]
          }
        }
        if (this.subCatalogId == '2010210') {
          this.selectDeviceData = this.camParamList[1].children[14]
        }
      }
      this.initDeviceParam(this.form, this.selectDeviceData);
      this.$nextTick(() => {
        this.renovate = !this.renovate;
      })
    },
    /**
     * 文件列表填充文件
     * @param {Object} item
     * dataScanRod - 扫描杆和替代体数据库文件列表
     */
    handleFileList(item) {
      let isDuplicate = this.dataScanRod.some(file => file.name === item.name);
      if (!isDuplicate) {
        this.dataScanRod.push(item);
      }
      this.sessionFile(this.dataScanRod, 'dataScanRod');
    }
  },
  created() {
    // 重置form下单方信息
    this.loadOrderParam()
    // 修改订单，读取订单详情信息和设置订单步骤环境
    this.loadingup()
    //设置是否显示对应适应症填写项
    this.setIs()
    // 获取session数据
    this.getData()
    // 添加表单规则
    this.addIs()
    this.getTemplateList()
    this.catalogList = catalogList;
    this.common.dict.get('biz_des_level').pop();
    this.desLevelMap = this.common.dict.get("biz_des_level")
    this.loadSubCatalogByCatalogId();
    this.$store.commit('common/recordNav', {
      navIndex: 1,
      navSubIndex: 0
    })
    // 重置订单下单方信息
    this.userId = getStore('userId');
    this.loading = false;
  },
  mounted() {
    // 在组件挂载DOM树后加载，刷新前处理
    this.think()
    // //创建订单第二步时是否显示设计师级别
    // if (this.currentStep == '2') {
    //   this.addClass()
    // }
    this.removeIs()
  },
  components: {
    BaseTag,
    YButton,
    YTooth,
    EleUploadImage,
    InputNum,
    BuyNum,
    Customer,
    paramTemplate,
    CanvasTooth,
    InputField,
    SelectField,
    InputNumberField,
    RadioField,
    SelIndication,
    ImpSys,
    orthodontics,
    FileHistory,
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/style/mixin";

.el-input-contact {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorContact);
  }
}

.el-input-phone {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPhone);
  }
}

.el-input-patient {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPatient);
  }
}

.el-input-ordercount {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorOrderCount);
  }
}

.el-input-orderamount {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorOrderAmount);
  }
}

.el-input-adhesivegap {
  /deep/ .select-input {
    color: var(--inputColorAdhesiveGap) !important;
  }
}

.el-input-adhesiveExtragap {
  /deep/ .select-input {
    color: var(--inputColorAdhesiveExtraGap) !important;
  }
}

.el-input-minthick {
  /deep/ .select-input {
    color: var(--inputColorMinThick) !important;
  }
}

.el-input-wallheight {
  /deep/ .select-input {
    color: var(--inputColorWallHeight) !important;
  }
}

.el-input-edgeLinedistance {
  /deep/ .select-input {
    color: var(--inputColorEdgeLineDistance) !important;
  }
}

.el-input-smoothdistance {
  /deep/ .select-input {
    color: var(--inputColorSmoothDistance) !important;
  }
}

.el-input-burradius {
  /deep/ .select-input {
    color: var(--inputColorBurRadius) !important;
  }
}

.el-input-burgapoffset {
  /deep/ .select-input {
    color: var(--inputColorBurGapOffset) !important;
  }
}

.el-input-edgelineoffset {
  /deep/ .select-input {
    color: var(--inputColorEdgeLineOffset) !important;
  }
}

.el-input-stretchoffset {
  /deep/ .select-input {
    color: var(--inputColorStretchOffset) !important;
  }
}

.el-input-angleoffset {
  /deep/ .select-input {
    color: var(--inputColorAngleOffset) !important;
  }
}

//
.el-input-occlusalClearance {
  /deep/ .select-input {
    color: var(--inputColorOcclusalClearance) !important;
  }
}

.el-input-adjacencyGap {
  /deep/ .select-input {
    color: var(--inputColorAdjacencyGap) !important;
  }
}

//
.el-input-tonguesideoffset {
  /deep/ .select-input {
    color: var(--inputColorTongueSideOffset) !important;
  }
}

.el-input-circlesideoffset {
  /deep/ .select-input {
    color: var(--inputColorCircleSideOffset) !important;
  }
}

.el-input-plateThickness {
  /deep/ .select-input {
    color: var(--inputColorPlateThickness) !important;
  }
}

.el-input-recessedRetention {
  /deep/ .select-input {
    color: var(--inputColorRecessedRetention) !important;
  }
}

.el-input-theGuideRing {
  /deep/ .select-input {
    color: var(--inputColorTheGuideRing) !important;
  }
}

.el-input-teethModel {
  /deep/ .select-input {
    color: var(--inputColorTeethModel) !important;
  }
}

.el-input-polymerization {
  /deep/ .select-input {
    color: var(--inputColorPolymerization) !important;
  }
}

.el-input-baseHeight {
  /deep/ .select-input {
    color: var(--inputColorBaseHeight) !important;
  }
}

.el-input-shoulderWidth {
  /deep/ .select-input {
    color: var(--inputColorShoulderWidth) !important;
  }
}

.el-input-shoulderAngle {
  /deep/ .select-input {
    color: var(--inputColorShoulderAngle) !important;
  }
}

.el-input-supragingival {
  /deep/ .select-input {
    color: var(--inputColorSupragingival) !important;
  }
}

.upload-demp {
  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    background-color: #f7f7f7;
  }

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}

.order {
  display: flex;
  flex-direction: column;
  perspective: 3000px;
  position: relative;
  z-index: 19;
  margin: 0 auto 10px;
}

.order-box {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 19;
  margin: 0 auto 16px;
  border-radius: 12px;

  &.el-card {
    border: none;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  ::v-deep .el-card__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }
}

.order-step {
  position: relative;
  overflow: hidden;
  background: transparent;
  min-height: 68px;
  line-height: 68px;
  font-size: 14px;
  color: #999;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  padding: 0 20px;
  margin: 8px auto;
}

.order-step-right {
  flex-shrink: 0;
  margin-right: 20px;

  .nav-sub-btn {
    margin: 0 8px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    padding: 6px 16px;
    font-size: 13px;
    background: #fff;
    color: #606266;
    cursor: pointer;
    transition: all 0.25s ease;
    outline: none;

    &.active {
      background: #1890ff;
      border-color: #1890ff;
      color: #fff;
      box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
    }

    &:not(.active):hover {
      color: #1890ff;
      border-color: rgba(24, 144, 255, 0.4);
    }
  }
}

.order-step-left {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  overflow: hidden;
  font-size: 14px;
  color: #999;
  width: 100%;
}

.order-step-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 20px;
  transition: all 0.3s ease;

  .step-number {
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border-radius: 50%;
    background: #e8e8e8;
    color: #999;
    font-size: 13px;
    font-weight: 600;
    margin-right: 8px;
    transition: all 0.3s ease;
  }

  .step-arrow {
    margin-left: 16px;
    font-size: 14px;
    color: #d9d9d9;
  }

  span {
    font-weight: 500;
    white-space: nowrap;
  }
}

.order-ops {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 0 12px 12px;
  margin-top: auto;
}

.order-detail-catalog {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
}

.order-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  height: 58px;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;

  > span {
    // font-size: 18px;
  }
}

.order-catalog {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 25vh;

  .box {
    overflow: hidden;
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }

  .content {
    float: left;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: 8px;
  }

  .content ::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    content: "";
    pointer-events: none;
  }

  .i {
    width: 180px;
    height: 120px;
    border-radius: 8px;
  }

  .cover-link {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    border-radius: 8px;
  }

  a {
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  a:hover {
    box-shadow: inset 0 0 38px rgba(0, 0, 0, .18);
    transition: all .15s ease;
  }

  .active {
    color: rgba(0, 160, 226, 1);
    border: 1px solid rgba(0, 160, 226, 0.58);
    border-radius: 8px;
  }

  span {
    line-height: 60px;
    text-align: center;
    font-size: 16px;
  }

}

.order-sub-catalog {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    align-self: center;
    margin: 0 36px;
  }

  .content {
    position: relative;
    float: left;
    width: 160px;
    height: 160px;
    border-radius: 8px;
    margin: 5px 10px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, .08);
  }

  .content ::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    content: "";
    pointer-events: none;
  }

  .sub-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .i {
    width: 110px;
    height: 110px;
    border-radius: 8px;
  }

  span {
    width: 100%;
    text-align: center;
    font-size: 13px;
    margin-top: 10px;
  }

  .cover-link {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    border-radius: 8px;
  }

  a {
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  a:hover {
    box-shadow: inset 0 0 38px rgba(0, 0, 0, .18);
    transition: all .15s ease;
  }

  .active {
    color: rgba(0, 160, 226, 1);
    border: 1px solid rgba(0, 160, 226, 0.58);
    border-radius: 8px;
  }

}

.step-done {
  color: #52c41a;

  .step-number {
    background: #52c41a !important;
    color: #fff !important;
  }
}

.step-active {
  color: #1890ff;

  .step-number {
    background: #1890ff !important;
    color: #fff !important;
  }
}

.arrow-done {
  color: #52c41a !important;
}

.order-detail-design {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
}

.order-basic-wrap {
  // flex: 1;
  width: 100%;
}

.order-input-wrap {
  // flex: 1;
  width: 100%;
  position: relative;
}


.dimension {
  position: absolute;
  top: 105px;
  right: 50px;
  font-size: 0.75rem;
  color: #20a0ff;

  p {
    letter-spacing: 1px;
  }
}

.input-form-wrap,
.input-form-wrap-row {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

// 输入框
.input-form-wrap {
  width: 33.33%;
  padding: 3px 10px;
  font-size: 13px;

  /deep/ .input-label {
    text-align: left !important;
    width: 120px;
  }
}

.input-form-wrap-row {
  width: 23%;
  padding: 10px 10px;
  font-size: 13px;
  margin-left: 1%;

  /deep/ .input-label {
    width: 120px;
    text-align: left !important;
  }
}

.input-textarea {
  padding: 5px 10px;
}

.item-history {
  display: flex;
  width: 100%;
  padding: 5px 10px;
}

.input-radio,
.input-select,
.input-form {
  width: 186px;
  height: 40px;
  display: flex;
  align-items: center;
}

/deep/ el-option {
  display: block !important;
}

.input-radio-box {
  width: 130px;
  height: 32px;
  padding-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
}

.order-detail-upload {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.input-type-wrap {
  width: 100%;
}

.input-upload-wrap {
  position: relative;

  .tip-btn1,
  .tip-btn2,
  .tip-btn3,
  .tip-btn4 {
    color: #20a0ff;
    font-size: 12px;
  }

  .tip-btn1 {
    position: absolute;
    top: 18px;
    left: 80px;
  }

  .tip-btn2 {
    position: absolute;
    top: 18px;
    left: 90px;
  }

  .tip-btn3 {
    position: absolute;
    top: 18px;
    left: 370px;
  }

  .tip-btn4 {
    position: absolute;
    top: 18px;
    left: 280px;
  }

  .load-advice,
  .load-advice-file {
    position: absolute;
    top: 108px;
    color: rgb(192, 196, 204);
  }

  .load-advice {
    left: 225px;
  }

  .load-advice-file {
    left: 450px;
  }
}

.order-upload-wrap {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.order-image-wrap,
.order-file-wrap {
  height: 120px;
  padding: 10px 5px 10px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, .1);
}

.order-file-wrap {
  padding: 10px;
  margin: 15px 0;
}

.upload-file {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.upload-file-dragger1 {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  margin-right: 80px;

  &:hover {
    border-color: #20a0ff;
  }
}

.upload-img {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.prompt {
  font-size: 13px;
  color: rgb(48, 154, 255);
  margin: 30px 0;
}

.dialog-ul {
  margin: 0 0 0 100px;
  list-style-type: none;
  width: 500px;
}

.dialog-ul img {
  width: 450px;
  height: auto;
  margin-left: 25px;
}

.advice,
.advice-CBCT {
  width: 450px;
  font-size: 15px;
  font-weight: 500;
}

.advice {
  margin: 10px 0 50px 25px;
}

.advice-CBCT {
  margin: 40px 0 10px 25px;
}

.adv-txt {
  text-align: center;
}

.title-little {
  margin-left: 20px;
}

.params-top {
  width: 100%;
  height: 50px;
}

.params-null-box {
  width: 17%;
}

.plate-param {
  width: 33%;
}

.promptWin {
  min-height: 100px;
  max-height: 500px;
  overflow-y: auto;
}

/deep/ .el-select-dropdown__item {
  display: block !important;
}

.spacing-height {
  line-height: 40px;
}

/deep/ .input-form-wrap,
.input-form-wrap-row {
  font-family: "宋体", Arial, sans-serif;
}

.shoulder {
  width: 360px;
  padding-left: 13px;
  line-height: 45px;
}

/deep/ .givging {
  margin-right: 5px;
}

#clinic {
  margin-left: 40px;
  margin-right: 10px;
}

#factory {
  margin-left: 41px;
}

.param-info::after,
.param-info-hat::after,
.param-info-part::after {
  content: '(黑色为默认参数，仅供参考)';
  font-size: 12px;
  position: absolute;
  top: 18px;
  left: 80px;
}

.param-info-hat::after {
  top: 18px;
  left: 150px;
}

.param-info-part::after {
  top: 18px;
  left: 110px;
}

.templateBtn {
  position: absolute;
  top: 13px;
  left: 240px;
}

.usingTemplate {
  position: absolute;
  top: 13px;
  left: 335px;
}

.addCard {
  width: 70px;
  border: 1px solid #ccc;
  border-radius: 10px;
  text-align: center;
  position: absolute;
  top: 15px;
  right: -75px;

  img {
    width: 50px;
    height: 50px;
    margin: 10px 10px 0 10px;
  }

  span {
    font-size: 8px;
  }
}

.toRight {
  float: right;
  display: block;
  margin-left: 10px;
}

.editText:hover {
  color: #3742fa;
}

.removeText:hover {
  color: #3742fa;
}

.toLeft {
  float: left;
  display: block;
  margin-left: 10px;
}

.el-icon-plus:before {
  line-height: 3;
}

// exo
.el-input-inner {
  /deep/ .select-input {
    color: var(--inputColorInner) !important;
  }
}

.el-input-occlusion {
  /deep/ .select-input {
    color: var(--inputColorOcclusion) !important;
  }
}

.el-input-adhesive {
  /deep/ .select-input {
    color: var(--inputColorAdhesive) !important;
  }
}

.el-input-edge-horizontal {
  /deep/ .select-input {
    color: var(--inputColorEdgeHorizontal) !important;
  }
}

.el-input-edge-tilt {
  /deep/ .select-input {
    color: var(--inputColorEdgeTilt) !important;
  }
}

.el-input-edge-inclination {
  /deep/ .select-input {
    color: var(--inputColorEdgeInclination) !important;
  }
}

.el-input-edge-vertical {
  /deep/ .select-input {
    color: var(--inputColorEdgeVertical) !important;
  }
}

.el-input-top {
  /deep/ .select-input {
    color: var(--inputColorTop) !important;
  }
}

.el-input-axial {
  /deep/ .select-input {
    color: var(--inputColorAxial) !important;
  }
}

.el-input-extra {
  /deep/ .select-input {
    color: var(--inputColorExtra) !important;
  }
}

.el-input-sectional {
  /deep/ .select-input {
    color: var(--inputColorSectional) !important;
  }
}

.el-input-prohibited {
  /deep/ .select-input {
    color: var(--inputColorProhibited) !important;
  }
}

.el-input-gingival {
  /deep/ .select-input {
    color: var(--inputColorGingival) !important;
  }
}

.el-input-distance {
  /deep/ .select-input {
    color: var(--inputColorDistance) !important;
  }
}

.el-input-margin-line {
  /deep/ .select-input {
    color: var(--inputColorMarginLine) !important;
  }
}

.el-input-cement {
  /deep/ .select-input {
    color: var(--inputColorCement) !important;
  }
}

.el-input-from {
  /deep/ .select-input {
    color: var(--inputColorFrom) !important;
  }
}

.el-input-margin-cement {
  /deep/ .select-input {
    color: var(--inputColorMarginCement) !important;
  }
}
</style>
<style lang="scss">
.adv-message {
  background-color: #ffeaa7;
  color: #ffa94d;
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// orderCreate.vue?ce03d200